import React, { useEffect, useState ,useMemo} from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import { PlusOutlined ,UploadOutlined,  ArrowUpOutlined,
  ArrowDownOutlined,SwapOutlined} from "@ant-design/icons";

// import socket from './../../socket';

import {
  Tabs,
  Table,
  Typography,
  Spin,
  Alert,
  message,
  Modal,
  Button,
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  Upload
} from 'antd';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
const { Search } = Input;
const { TextArea } = Input;

function normalize(v) {
  if (v === null || v === undefined) return '';
  return String(v).trim().toUpperCase();
}

// try to extract month name from RegisteredBatch or RegisteredBatch-like strings
const monthFromRegisteredBatch = (str) => {
  if (!str) return '';
  // split by non-word characters
  const parts = String(str).split(/[^A-Za-z]+/).map(p => p.trim()).filter(Boolean);
  for (const p of parts) {
    if (/^[A-Za-z]+$/.test(p)) {
      return p.toUpperCase();
    }
  }
  return '';
};


function Leads() {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');


const [isUploadCSVModalOpen, setIsUploadCSVModalOpen] = useState(false);
const [csvFile, setCsvFile] = useState(null);
const [uploadingCSV, setUploadingCSV] = useState(false);
const [uploadFileList, setUploadFileList] = useState([]);


const [callStatusModalVisible, setCallStatusModalVisible] = useState(false);
const [callStatusRecord, setCallStatusRecord] = useState(null);
const [callStatusValue, setCallStatusValue] = useState(null);
const [callStatusLoading, setCallStatusLoading] = useState(false);

const [commentModalVisible, setCommentModalVisible] = useState(false);
const [commentRecord, setCommentRecord] = useState(null);
const [commentValue, setCommentValue] = useState("");
const [commentLoading, setCommentLoading] = useState(false);

const [professionalCallStatusModalVisible, setProfessionalCallStatusModalVisible] = useState(false);
const [professionalCallStatusRecord, setProfessionalCallStatusRecord] = useState(null);
const [professionalCallStatusValue, setProfessionalCallStatusValue] = useState(null);
const [professionalCallStatusLoading, setProfessionalCallStatusLoading] = useState(false);

const [professionalCommentModalVisible, setProfessionalCommentModalVisible] = useState(false);
const [professionalCommentRecord, setProfessionalCommentRecord] = useState(null);
const [professionalCommentValue, setProfessionalCommentValue] = useState("");
const [professionalCommentLoading, setProfessionalCommentLoading] = useState(false);

// ================= STATES =================

const [leadDateSortOrder,
  setLeadDateSortOrder] =
  useState(null);

  // ================= STATES =================

// const [leadSourceSortOrder,
//   setLeadSourceSortOrder] =
//   useState("asc");

  // ================= STATES =================
const [availabilityBatchSortOrder,
  setAvailabilityBatchSortOrder] =
  useState(null);

  

// ================= STATES =================

const [isUploadProfessionalCSVModalOpen,
  setIsUploadProfessionalCSVModalOpen] =
  useState(false);

const [professionalCSVFile,
  setProfessionalCSVFile] =
  useState(null);

const [uploadingProfessionalCSV,
  setUploadingProfessionalCSV] =
  useState(false);

const [professionalUploadFileList,
  setProfessionalUploadFileList] =
  useState([]);


  const [professionalLeadDateSortOrder,
  setProfessionalLeadDateSortOrder] =
  useState(null);

const [professionalAvailabilityBatchSortOrder,
  setProfessionalAvailabilityBatchSortOrder] =
  useState(null);


  const base = (role === 'ADMIN') ? "/admin-home" : "/user-home";
  const fullPath = `${base}/dashboard-leads`;

  useEffect(() => {
    const verifyUser = async () => {
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/check-user`,
          { email, role, token }
        );

        if (!res.data.success) {
          const errMsg = res?.data?.message || 'Please Login Again.';
          toast.error(errMsg);
          localStorage.removeItem('token');
          localStorage.removeItem('tempToken');
          localStorage.removeItem('email');
          localStorage.removeItem('fullName');
          localStorage.removeItem('role');
          navigate('/login');
        }
      } catch (error) {
        const msg =
          error?.response?.data?.message || error?.message || 'Please Login Again.';
        toast.error(msg);
        localStorage.removeItem('token');
        localStorage.removeItem('tempToken');
        localStorage.removeItem('email');
        localStorage.removeItem('fullName');
        localStorage.removeItem('role');
        navigate('/login');
      }
    };

    verifyUser();
  }, [navigate, location.pathname, token, email, role]);

  // --- Leads data states ---
  const [students, setStudents] = useState([]);
  const [professionals, setProfessionals] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [loadingProfessionals, setLoadingProfessionals] = useState(false);
  const [error, setError] = useState(null);
  const [movingKeys, setMovingKeys] = useState(new Set());

  // --- Modal / form state ---
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false);
  const [isProfessionalModalOpen, setIsProfessionalModalOpen] = useState(false);
  const [submittingStudent, setSubmittingStudent] = useState(false);
  const [submittingProfessional, setSubmittingProfessional] = useState(false);

  // editing flags + record
  const [isEditingStudent, setIsEditingStudent] = useState(false);
  const [isEditingProfessional, setIsEditingProfessional] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null); // generic holder

  const [studentForm] = Form.useForm();
  const [professionalForm] = Form.useForm();

   const fetchStudents = async () => {
      setLoadingStudents(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/leads/all-leads-student`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = Array.isArray(res.data) ? res.data : res.data.data || [];
        setStudents(data.map((row, idx) => ({ key: row.Email ?? idx, ...row })));
      } catch (err) {
        console.error('Failed to fetch student leads', err);
        setError('Failed to load student leads');
      } finally {
        setLoadingStudents(false);
      }
    };

    const fetchProfessionals = async () => {
      setLoadingProfessionals(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/leads/all-leads-professional`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = Array.isArray(res.data) ? res.data : res.data.data || [];
        setProfessionals(data.map((row, idx) => ({ key: row.Email ?? idx, ...row })));
      } catch (err) {
        console.error('Failed to fetch professional leads', err);
        setError('Failed to load professional leads');
      } finally {
        setLoadingProfessionals(false);
      }
    };


  useEffect(() => {
   
    if (token) {
      fetchStudents();
      fetchProfessionals();
    }
  }, [token, location.key]);



   // ----------- Filters (shared) -----------
    const [filterFullNameText, setFilterFullNameText] = useState('');
    const [filterEmailText, setFilterEmailText] = useState('');
  
    // ----------- Student-specific filters -----------
    const [studentSources, setStudentSources] = useState([]); // multi
    const [studentRegisteredMonth, setStudentRegisteredMonth] = useState(null); // single month like 'OCTOBER'
    const [studentBatchDays, setStudentBatchDays] = useState([]); // multi
    const [studentEnrollmentType, setStudentEnrollmentType] = useState(null);
    const [studentCallStatus, setStudentCallStatus] = useState([]);
    // ----------- Professional-specific filters -----------
    const [profSources, setProfSources] = useState([]); // multi
    const [profYears, setProfYears] = useState([]); // multi
    const [profRegisteredMonth, setProfRegisteredMonth] = useState(null);
    const [profBatchDays, setProfBatchDays] = useState([]);
    const [profEnrollmentType, setProfEnrollmentType] = useState(null);
    const [professionalCallStatus, setProfessionalCallStatus] = useState([]);
    // helper for name/email matching
    const matchesText = (value, query) => {
      if (!query) return true;
      if (!value) return false;
      return normalize(value).includes(normalize(query));
    };
  
    // ---------- Filtered lists using useMemo ----------
    const filteredStudents = useMemo(() => {
      if (!Array.isArray(students)) return [];
      return students.filter((r) => {
        // name/email
        if (!matchesText(r.FullName, filterFullNameText)) return false;
        if (!matchesText(r.Email, filterEmailText)) return false;
  
        // LeadSource
        if (studentSources.length) {
          const src = normalize(r.LeadSource);
          const allowed = studentSources.map(s => normalize(s));
          if (!allowed.includes(src)) return false;
        }
  
  
        // Enrollment Type (single)
  if (studentEnrollmentType) {
    const v = normalize(r.EnrollmentType || '');
    if (v !== normalize(studentEnrollmentType)) return false;
  }
  
        // Registered month
        if (studentRegisteredMonth) {
          const month = monthFromRegisteredBatch(r.AvailabilityBatch); // e.g. OCTOBER
          if (!month) return false;
          if (normalize(month) !== normalize(studentRegisteredMonth)) return false;
        }
  
        // BatchDay
        if (studentBatchDays.length) {
          const bd = normalize(r.BatchDay);
          const allowed = studentBatchDays.map(s => normalize(s));
          if (!allowed.includes(bd)) return false;
        }

        if (studentCallStatus.length) {
          const bd = normalize(r.CallStatus);
          const allowed = studentCallStatus.map(s => normalize(s));
          if (!allowed.includes(bd)) return false;
        }
  
        return true;
      });
    }, [
      students,
      filterFullNameText,
      filterEmailText,
      studentSources,
      studentEnrollmentType,
      studentRegisteredMonth,
      studentBatchDays,
      studentCallStatus
    ]);
  
    const filteredProfessionals = useMemo(() => {
      if (!Array.isArray(professionals)) return [];
      return professionals.filter((r) => {
        // name/email
        if (!matchesText(r.FullName, filterFullNameText)) return false;
        if (!matchesText(r.Email, filterEmailText)) return false;
  
        // LeadSource
        if (profSources.length) {
          const src = normalize(r.LeadSource);
          const allowed = profSources.map(s => normalize(s));
          if (!allowed.includes(src)) return false;
        }
  
       
        // Years of exp
        if (profYears.length) {
          const y = normalize(String(r.YearsOfExperience || r.YearsOfExp || ''));
          const allowed = profYears.map(s => normalize(String(s)));
          if (!allowed.includes(y)) return false;
        }
  
        // Registered month
        if (profRegisteredMonth) {
          const month = monthFromRegisteredBatch(r.AvailabilityBatch);
          if (!month) return false;
          if (normalize(month) !== normalize(profRegisteredMonth)) return false;
        }
  
        if (profEnrollmentType) {
    const v = normalize(r.EnrollmentType || '');
    if (v !== normalize(profEnrollmentType)) return false;
  }
  
        // BatchDay
        if (profBatchDays.length) {
          const bd = normalize(r.BatchDay);
          const allowed = profBatchDays.map(s => normalize(s));
          if (!allowed.includes(bd)) return false;
        }
  
       if (professionalCallStatus.length) {
          const bd = normalize(r.CallStatus);
          const allowed = professionalCallStatus.map(s => normalize(s));
          if (!allowed.includes(bd)) return false;
        }
        return true;
      });
    }, [
      professionals,
      filterFullNameText,
      filterEmailText,
      profSources,
      profYears,
      profRegisteredMonth,
      profEnrollmentType,
      profBatchDays,
      professionalCallStatus
    ]);


    // ---------- Clear filters helpers ----------
  const clearAllFilters = () => {
    setFilterFullNameText('');
    setFilterEmailText('');
    setStudentSources([]);
    setStudentCallStatus([])
    
    setStudentRegisteredMonth(null);
    setStudentBatchDays([]);
    setStudentEnrollmentType(null);
    setProfEnrollmentType(null);
    setProfSources([]);
  
    setProfYears([]);
    setProfRegisteredMonth(null);
    setProfBatchDays([]);
    setProfessionalCallStatus([])
  };

  const clearStudentFilters = () => {
    setStudentSources([]);
        setStudentCallStatus([])
   
     setStudentEnrollmentType(null);
    setStudentRegisteredMonth(null);
    setStudentBatchDays([]);
  };

  const clearProfessionalFilters = () => {
    setProfSources([]);
     setProfessionalCallStatus([])
    setProfYears([]);
     setProfEnrollmentType(null);
    setProfRegisteredMonth(null);
    setProfBatchDays([]);
  };


  // --- Move to demo (unchanged) ---
  const handleMoveToNextStage = async (record) => {
    if (!record || !record.Email) {
      toast.error('Selected record missing Email');
      return;
    }

    const payload = {
      Email: record.Email,
      LeadCategory: record.LeadCategory ?? '',
    };

    setMovingKeys((prev) => {
      const next = new Set(prev);
      next.add(record.key);
      return next;
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/leads/from-leads-to-demo`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res?.data?.success || res?.status === 201) {
        toast.success(res?.data?.message || 'Moved to Demo Stage');
        setStudents((prev) => prev.filter((r) => r.key !== record.key && r.Email !== record.Email));
        setProfessionals((prev) => prev.filter((r) => r.key !== record.key && r.Email !== record.Email));
            // ✅ CLOSE MODAL
  setActionModalVisible(false);
      } else {
        const errMsg = res?.data?.message || 'Failed to move to demo stage';
        toast.error(errMsg);
      }
    } catch (err) {
      console.error('Move to demo failed', err);
      const errMsg = err?.response?.data?.message || 'Network / server error';
      toast.error(errMsg);
    } finally {
      setMovingKeys((prev) => {
        const next = new Set(prev);
        next.delete(record.key);
        return next;
      });
    }
  };

  // --- Helpers for opening modals (add or edit) ---
  const openStudentModal = (record = null) => {
    if (record) {
      setIsEditingStudent(true);
      setEditingRecord(record);

      // parse PhoneNumber into CountryCode + PhoneNumber (best-effort)
      let country = '+91';
      let phone = '';
      if (record.PhoneNumber) {
        const parts = record.PhoneNumber.split(' ');
        if (parts.length >= 2 && parts[0].startsWith('+')) {
          country = parts[0];
          phone = parts.slice(1).join(' ');
        } else {
          phone = record.PhoneNumber;
        }
      }

      studentForm.setFieldsValue({
        FullName: record.FullName || '',
        Email: record.Email || '',
        CountryCode: country,
        PhoneNumber: phone,
        LeadCategory: record.LeadCategory || 'STUDENT',
        LeadSource: record.LeadSource || undefined,
        EnrollmentType: record.EnrollmentType || undefined,
        CollegeName: record.CollegeName || '',
        PassedOutYear: record.PassedOutYear || '',
        AvailabilityBatch: record.AvailabilityBatch ? dayjs(record.AvailabilityBatch) : undefined,
        BatchDay: record.BatchDay || undefined,
        CallBack: record.CallBack || undefined,
      });
      setIsStudentModalOpen(true);
    } else {
      setIsEditingStudent(false);
      setEditingRecord(null);
      studentForm.resetFields();
      setIsStudentModalOpen(true);
    }
  };

  const closeStudentModal = () => {
    studentForm.resetFields();
    setIsStudentModalOpen(false);
    setIsEditingStudent(false);
    setEditingRecord(null);
  };

  // Student submit handles both add and update
  const submitStudent = async (values) => {
    setSubmittingStudent(true);
    try {
      const FullName = values.FullName ?? '';
      const Email = values.Email ?? '';
      const PhoneNumber = `${values.CountryCode || '+91'} ${values.PhoneNumber || ''}`.trim();
      const LeadCategory = values.LeadCategory ?? 'Student';
      const LeadSource = values.LeadSource ?? '';
      const EnrollmentType = values.EnrollmentType;
      const CollegeName = values.CollegeName ?? '';
      const PassedOutYear = values.PassedOutYear ?? '';
      const AvailabilityBatch = values.AvailabilityBatch
        ? values.AvailabilityBatch.format('YYYY-MM-DD')
        : '';
      const BatchDay = values.BatchDay ?? '';
      const CallBack = values.CallBack ?? '';

      const payload = {
        FullName,
        Email,
        PhoneNumber,
        LeadCategory,
        LeadSource,
        EnrollmentType,
        CollegeName,
        PassedOutYear,
        AvailabilityBatch,
        BatchDay,
        CallBack,
      };

      if (isEditingStudent && editingRecord) {
        // Update flow (PUT). Adjust endpoint if your backend differs.
        const res = await axios.put(
          `${process.env.REACT_APP_API_URL}/leads/update-student`,
          { ...payload, originalEmail: editingRecord.Email },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res?.data?.success || res?.status === 200) {
          const updated = res?.data?.data || payload;

          setStudents(prev => prev.map(r => {
            if (r.key === editingRecord.key || r.Email === editingRecord.Email) {
              return {
                ...r,
                ...updated,
                AvailabilityBatch: updated.AvailabilityBatch ? dayjs(updated.AvailabilityBatch).format('DD-MM-YYYY') : ''
              };
            }
            return r;
          }));

          toast.success(res?.data?.message || 'Student lead updated');
          closeStudentModal();
        } else {
          toast.error(res?.data?.message || 'Failed to update student lead');
        }
      } else {
        // Add flow
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/leads/form-student`,
          payload
        );

        if (res?.data?.success || res?.status === 201) {
          const created = res?.data?.data || res?.data?.lead || payload;

          const uiRow = {
            ...created,
            key: created.Email || `${created.FullName || 'student'}-${Date.now()}`,
            AvailabilityBatch: created.AvailabilityBatch
              ? dayjs(created.AvailabilityBatch).format('DD-MM-YYYY')
              : '',
          };

          setStudents(prev => [uiRow, ...prev]);
          toast.success(res?.data?.message || 'Student lead added');
          studentForm.resetFields();
          setIsStudentModalOpen(false);
        } else {
          const errMsg = res?.data?.message || 'Failed to add student lead';
          toast.error(errMsg);
        }
      }
    } catch (err) {
      console.error('Add/Update student failed', err);
      const errMsg = err?.response?.data?.message || 'Network / server error';
      toast.error(errMsg);
    } finally {
      setSubmittingStudent(false);
    }
  };


  // ================= OPEN/CLOSE MODAL =================

const openUploadCSVModal = () => {
  setIsUploadCSVModalOpen(true);
};

const closeUploadCSVModal = () => {

  setIsUploadCSVModalOpen(false);

  // CLEAR FILE
  setCsvFile(null);

  // CLEAR UPLOAD UI
  setUploadFileList([]);

};


// ================= HANDLE CSV UPLOAD =================

const handleUploadCSV = async () => {

  try {

    if (!csvFile) {
      return toast.error("Please select CSV file");
    }

    setUploadingCSV(true);

    const formData = new FormData();
    formData.append("file", csvFile);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/leads/upload-student-csv`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

   if (response?.data?.success || response?.status === 201) {

  const uploadedStudents = response?.data?.students || [];

  const formattedStudents = uploadedStudents.map((student) => ({
    ...student,

    key:
      student.Email ||
      `${student.FullName || "student"}-${Date.now()}`,

    AvailabilityBatch:
      student.AvailabilityBatch &&
      student.AvailabilityBatch !== "NA"
        ? dayjs(student.AvailabilityBatch).format("DD-MM-YYYY")
        : "NA",
  }));

  
  
  toast.success(
    `${response.data.inserted} Students Uploaded Successfully`
  );

  if (response.data.skipped > 0) {

    toast.info(
      `${response.data.skipped} Duplicate Students Skipped`
    );

  }

  fetchStudents();

  closeUploadCSVModal();

}

  } catch (error) {

    console.error(error);

    toast.error(
      error?.response?.data?.message || "CSV Upload Failed"
    );

  } finally {

    setUploadingCSV(false);

  }

};



  // --- Professional modal handlers (add + edit similar) ---
  const openProfessionalModal = (record = null) => {
    if (record) {
      setIsEditingProfessional(true);
      setEditingRecord(record);

      let country = '+91';
      let phone = '';
      if (record.PhoneNumber) {
        const parts = record.PhoneNumber.split(' ');
        if (parts.length >= 2 && parts[0].startsWith('+')) {
          country = parts[0];
          phone = parts.slice(1).join(' ');
        } else {
          phone = record.PhoneNumber;
        }
      }

      professionalForm.setFieldsValue({
        FullName: record.FullName || '',
        Email: record.Email || '',
        CountryCode: country,
        PhoneNumber: phone,
        LeadCategory: record.LeadCategory || 'PROFESSIONAL',
        LeadSource: record.LeadSource || undefined,
        EnrollmentType: record.EnrollmentType || undefined,
        YearsOfExperience: record.YearsOfExperience || '',
        CompanyName: record.CompanyName || '',
        AvailabilityBatch: record.AvailabilityBatch ? dayjs(record.AvailabilityBatch) : undefined,
        BatchDay: record.BatchDay || undefined,
        CallBack: record.CallBack || undefined,
      });
      setIsProfessionalModalOpen(true);
    } else {
      setIsEditingProfessional(false);
      setEditingRecord(null);
      professionalForm.resetFields();
      setIsProfessionalModalOpen(true);
    }
  };

  const closeProfessionalModal = () => {
    professionalForm.resetFields();
    setIsProfessionalModalOpen(false);
    setIsEditingProfessional(false);
    setEditingRecord(null);
  };

  const submitProfessional = async (values) => {
    setSubmittingProfessional(true);
    try {
      const FullName = values.FullName ?? "";
      const Email = values.Email ?? "";
      const PhoneNumber = `${values.CountryCode || '+91'} ${values.PhoneNumber || ''}`.trim();
      const LeadCategory = values.LeadCategory ?? "Professional";
      const LeadSource = values.LeadSource ?? "";
      const EnrollmentType = values.EnrollmentType;
      const YearsOfExperience = values.YearsOfExperience ?? "";
      const CompanyName = values.CompanyName ?? "";
      const AvailabilityBatch = values.AvailabilityBatch
        ? values.AvailabilityBatch.format("YYYY-MM-DD")
        : "";
      const BatchDay = values.BatchDay ?? "";
      const CallBack = values.CallBack ?? "";

      const payload = {
        FullName,
        Email,
        PhoneNumber,
        LeadCategory,
        LeadSource,
        EnrollmentType,
        YearsOfExperience,
        CompanyName,
        AvailabilityBatch,
        BatchDay,
        CallBack,
      };

      if (isEditingProfessional && editingRecord) {
        // Update professional (PUT). Adjust endpoint if backend differs.
        const res = await axios.put(
          `${process.env.REACT_APP_API_URL}/leads/update-professional`,
          { ...payload, originalEmail: editingRecord.Email },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res?.data?.success || res?.status === 200) {
          const updated = res?.data?.data || payload;

          setProfessionals(prev => prev.map(r => {
            if (r.key === editingRecord.key || r.Email === editingRecord.Email) {
              return {
                ...r,
                ...updated,
                AvailabilityBatch: updated.AvailabilityBatch ? dayjs(updated.AvailabilityBatch).format('DD-MM-YYYY') : ''
              };
            }
            return r;
          }));

          toast.success(res?.data?.message || 'Professional lead updated');
          closeProfessionalModal();
        } else {
          toast.error(res?.data?.message || 'Failed to update professional lead');
        }
      } else {
        // Add flow
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/leads/form-professional`,
          payload
        );

        if (res?.data?.success || res?.status === 201) {
          const created = res?.data?.data || res?.data?.lead || payload;

          const uiRow = {
            ...created,
            key: created.Email || `${created.FullName || 'prof'}-${Date.now()}`,
            AvailabilityBatch: created.AvailabilityBatch
              ? dayjs(created.AvailabilityBatch).format('DD-MM-YYYY')
              : '',
          };

          setProfessionals(prev => [uiRow, ...prev]);
          toast.success(res?.data?.message || "Professional lead added");
          professionalForm.resetFields();
          setIsProfessionalModalOpen(false);
        } else {
          toast.error(res?.data?.message || "Failed to add professional lead");
        }
      }
    } catch (err) {
      console.error("Add/Update professional failed", err);
      toast.error(err?.response?.data?.message || "Network / server error");
    } finally {
      setSubmittingProfessional(false);
    }
  };

  // ================= OPEN/CLOSE MODAL =================

const openUploadProfessionalCSVModal = () => {

  setIsUploadProfessionalCSVModalOpen(true);

};

const closeUploadProfessionalCSVModal = () => {

  setIsUploadProfessionalCSVModalOpen(false);

  setProfessionalCSVFile(null);

  setProfessionalUploadFileList([]);

};

// ================= HANDLE PROFESSIONAL CSV UPLOAD =================

const handleUploadProfessionalCSV = async () => {

  try {

    if (!professionalCSVFile) {

      return toast.error(
        "Please select CSV file"
      );

    }

    setUploadingProfessionalCSV(true);

    const formData = new FormData();

    formData.append(
      "file",
      professionalCSVFile
    );

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/leads/upload-professionals-csv`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",

          Authorization:
            `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (
      response?.data?.success ||
      response?.status === 201
    ) {

      const uploadedProfessionals =
        response?.data?.professionals || [];

      const formattedProfessionals =
        uploadedProfessionals.map(
          (professional) => ({
            ...professional,

            key:
              professional.Email ||
              `${professional.FullName || "professional"}-${Date.now()}`,

            AvailabilityBatch:
              professional.AvailabilityBatch &&
              professional.AvailabilityBatch !== "NA"
                ? dayjs(
                    professional.AvailabilityBatch
                  ).format("DD-MM-YYYY")
                : "NA",
          })
        );

      toast.success(
        `${response.data.inserted} Professionals Uploaded Successfully`
      );

      if (response.data.skipped > 0) {

        toast.info(
          `${response.data.skipped} Duplicate Professionals Skipped`
        );

      }

      fetchProfessionals();

      closeUploadProfessionalCSVModal();

    }

  } catch (error) {

    console.error(error);

    toast.error(
      error?.response?.data?.message ||
      "Professional CSV Upload Failed"
    );

  } finally {

    setUploadingProfessionalCSV(false);

  }

};

  const COUNTRIES = [
    { name: "Afghanistan", dial_code: "+93" },
    { name: "Albania", dial_code: "+355" },
    { name: "Algeria", dial_code: "+213" },
    { name: "American Samoa", dial_code: "+1684" },
    { name: "Andorra", dial_code: "+376" },
    { name: "Angola", dial_code: "+244" },
    { name: "Anguilla", dial_code: "+1264" },
    { name: "Antarctica", dial_code: "+672" },
    { name: "Antigua and Barbuda", dial_code: "+1268" },
    { name: "Argentina", dial_code: "+54" },
    { name: "Armenia", dial_code: "+374" },
    { name: "Aruba", dial_code: "+297" },
    { name: "Australia", dial_code: "+61" },
    { name: "Austria", dial_code: "+43" },
    { name: "Azerbaijan", dial_code: "+994" },
    { name: "Bahamas", dial_code: "+1242" },
    { name: "Bahrain", dial_code: "+973" },
    { name: "Bangladesh", dial_code: "+880" },
    { name: "Barbados", dial_code: "+1246" },
    { name: "Belarus", dial_code: "+375" },
    { name: "Belgium", dial_code: "+32" },
    { name: "Belize", dial_code: "+501" },
    { name: "Benin", dial_code: "+229" },
    { name: "Bermuda", dial_code: "+1441" },
    { name: "Bhutan", dial_code: "+975" },
    { name: "Bolivia", dial_code: "+591" },
    { name: "Bosnia and Herzegovina", dial_code: "+387" },
    { name: "Botswana", dial_code: "+267" },
    { name: "Brazil", dial_code: "+55" },
    { name: "British Indian Ocean Territory", dial_code: "+246" },
    { name: "Brunei Darussalam", dial_code: "+673" },
    { name: "Bulgaria", dial_code: "+359" },
    { name: "Burkina Faso", dial_code: "+226" },
    { name: "Burundi", dial_code: "+257" },
    { name: "Cabo Verde", dial_code: "+238" },
    { name: "Cambodia", dial_code: "+855" },
    { name: "Cameroon", dial_code: "+237" },
    { name: "Canada", dial_code: "+1" },
    { name: "Cayman Islands", dial_code: "+1345" },
    { name: "Central African Republic", dial_code: "+236" },
    { name: "Chad", dial_code: "+235" },
    { name: "Chile", dial_code: "+56" },
    { name: "China", dial_code: "+86" },
    { name: "Christmas Island", dial_code: "+61" },
    { name: "Cocos (Keeling) Islands", dial_code: "+61" },
    { name: "Colombia", dial_code: "+57" },
    { name: "Comoros", dial_code: "+269" },
    { name: "Congo", dial_code: "+242" },
    { name: "Congo (Democratic Republic)", dial_code: "+243" },
    { name: "Cook Islands", dial_code: "+682" },
    { name: "Costa Rica", dial_code: "+506" },
    { name: "Croatia", dial_code: "+385" },
    { name: "Cuba", dial_code: "+53" },
    { name: "Cyprus", dial_code: "+357" },
    { name: "Czech Republic", dial_code: "+420" },
    { name: "Denmark", dial_code: "+45" },
    { name: "Djibouti", dial_code: "+253" },
    { name: "Dominica", dial_code: "+1767" },
    { name: "Dominican Republic", dial_code: "+1" },
    { name: "Ecuador", dial_code: "+593" },
    { name: "Egypt", dial_code: "+20" },
    { name: "El Salvador", dial_code: "+503" },
    { name: "Equatorial Guinea", dial_code: "+240" },
    { name: "Eritrea", dial_code: "+291" },
    { name: "Estonia", dial_code: "+372" },
    { name: "Eswatini", dial_code: "+268" },
    { name: "Ethiopia", dial_code: "+251" },
    { name: "Falkland Islands", dial_code: "+500" },
    { name: "Faroe Islands", dial_code: "+298" },
    { name: "Fiji", dial_code: "+679" },
    { name: "Finland", dial_code: "+358" },
    { name: "France", dial_code: "+33" },
    { name: "French Guiana", dial_code: "+594" },
    { name: "French Polynesia", dial_code: "+689" },
    { name: "Gabon", dial_code: "+241" },
    { name: "Gambia", dial_code: "+220" },
    { name: "Georgia", dial_code: "+995" },
    { name: "Germany", dial_code: "+49" },
    { name: "Ghana", dial_code: "+233" },
    { name: "Gibraltar", dial_code: "+350" },
    { name: "Greece", dial_code: "+30" },
    { name: "Greenland", dial_code: "+299" },
    { name: "Grenada", dial_code: "+1473" },
    { name: "Guadeloupe", dial_code: "+590" },
    { name: "Guam", dial_code: "+1671" },
    { name: "Guatemala", dial_code: "+502" },
    { name: "Guernsey", dial_code: "+441481" },
    { name: "Guinea", dial_code: "+224" },
    { name: "Guinea-Bissau", dial_code: "+245" },
    { name: "Guyana", dial_code: "+592" },
    { name: "Haiti", dial_code: "+509" },
    { name: "Honduras", dial_code: "+504" },
    { name: "Hong Kong", dial_code: "+852" },
    { name: "Hungary", dial_code: "+36" },
    { name: "Iceland", dial_code: "+354" },
    { name: "India", dial_code: "+91" },
    { name: "Indonesia", dial_code: "+62" },
    { name: "Iran", dial_code: "+98" },
    { name: "Iraq", dial_code: "+964" },
    { name: "Ireland", dial_code: "+353" },
    { name: "Isle of Man", dial_code: "+441624" },
    { name: "Israel", dial_code: "+972" },
    { name: "Italy", dial_code: "+39" },
    { name: "Jamaica", dial_code: "+1876" },
    { name: "Japan", dial_code: "+81" },
    { name: "Jersey", dial_code: "+441534" },
    { name: "Jordan", dial_code: "+962" },
    { name: "Kazakhstan", dial_code: "+7" },
    { name: "Kenya", dial_code: "+254" },
    { name: "Kiribati", dial_code: "+686" },
    { name: "Kuwait", dial_code: "+965" },
    { name: "Kyrgyzstan", dial_code: "+996" },
    { name: "Laos", dial_code: "+856" },
    { name: "Latvia", dial_code: "+371" },
    { name: "Lebanon", dial_code: "+961" },
    { name: "Lesotho", dial_code: "+266" },
    { name: "Liberia", dial_code: "+231" },
    { name: "Libya", dial_code: "+218" },
    { name: "Liechtenstein", dial_code: "+423" },
    { name: "Lithuania", dial_code: "+370" },
    { name: "Luxembourg", dial_code: "+352" },
    { name: "Macao", dial_code: "+853" },
    { name: "Madagascar", dial_code: "+261" },
    { name: "Malawi", dial_code: "+265" },
    { name: "Malaysia", dial_code: "+60" },
    { name: "Maldives", dial_code: "+960" },
    { name: "Mali", dial_code: "+223" },
    { name: "Malta", dial_code: "+356" },
    { name: "Marshall Islands", dial_code: "+692" },
    { name: "Martinique", dial_code: "+596" },
    { name: "Mauritania", dial_code: "+222" },
    { name: "Mauritius", dial_code: "+230" },
    { name: "Mexico", dial_code: "+52" },
    { name: "Micronesia", dial_code: "+691" },
    { name: "Moldova", dial_code: "+373" },
    { name: "Monaco", dial_code: "+377" },
    { name: "Mongolia", dial_code: "+976" },
    { name: "Montenegro", dial_code: "+382" },
    { name: "Montserrat", dial_code: "+1664" },
    { name: "Morocco", dial_code: "+212" },
    { name: "Mozambique", dial_code: "+258" },
    { name: "Myanmar", dial_code: "+95" },
    { name: "Namibia", dial_code: "+264" },
    { name: "Nauru", dial_code: "+674" },
    { name: "Nepal", dial_code: "+977" },
    { name: "Netherlands", dial_code: "+31" },
    { name: "New Caledonia", dial_code: "+687" },
    { name: "New Zealand", dial_code: "+64" },
    { name: "Nicaragua", dial_code: "+505" },
    { name: "Niger", dial_code: "+227" },
    { name: "Nigeria", dial_code: "+234" },
    { name: "Niue", dial_code: "+683" },
    { name: "Norfolk Island", dial_code: "+672" },
    { name: "North Korea", dial_code: "+850" },
    { name: "North Macedonia", dial_code: "+389" },
    { name: "Northern Mariana Islands", dial_code: "+1670" },
    { name: "Norway", dial_code: "+47" },
    { name: "Oman", dial_code: "+968" },
    { name: "Pakistan", dial_code: "+92" },
    { name: "Palau", dial_code: "+680" },
    { name: "Palestine", dial_code: "+970" },
    { name: "Panama", dial_code: "+507" },
    { name: "Papua New Guinea", dial_code: "+675" },
    { name: "Paraguay", dial_code: "+595" },
    { name: "Peru", dial_code: "+51" },
    { name: "Philippines", dial_code: "+63" },
    { name: "Pitcairn", dial_code: "+64" },
    { name: "Poland", dial_code: "+48" },
    { name: "Portugal", dial_code: "+351" },
    { name: "Puerto Rico", dial_code: "+1" },
    { name: "Qatar", dial_code: "+974" },
    { name: "Réunion", dial_code: "+262" },
    { name: "Romania", dial_code: "+40" },
    { name: "Russia", dial_code: "+7" },
    { name: "Rwanda", dial_code: "+250" },
    { name: "Saint Kitts and Nevis", dial_code: "+1869" },
    { name: "Saint Lucia", dial_code: "+1758" },
    { name: "Saint Vincent and the Grenadines", dial_code: "+1784" },
    { name: "Samoa", dial_code: "+685" },
    { name: "San Marino", dial_code: "+378" },
    { name: "Saudi Arabia", dial_code: "+966" },
    { name: "Senegal", dial_code: "+221" },
    { name: "Serbia", dial_code: "+381" },
    { name: "Seychelles", dial_code: "+248" },
    { name: "Sierra Leone", dial_code: "+232" },
    { name: "Singapore", dial_code: "+65" },
    { name: "Slovakia", dial_code: "+421" },
    { name: "Slovenia", dial_code: "+386" },
    { name: "Solomon Islands", dial_code: "+677" },
    { name: "Somalia", dial_code: "+252" },
    { name: "South Africa", dial_code: "+27" },
    { name: "South Korea", dial_code: "+82" },
    { name: "South Sudan", dial_code: "+211" },
    { name: "Spain", dial_code: "+34" },
    { name: "Sri Lanka", dial_code: "+94" },
    { name: "Sudan", dial_code: "+249" },
    { name: "Suriname", dial_code: "+597" },
    { name: "Sweden", dial_code: "+46" },
    { name: "Switzerland", dial_code: "+41" },
    { name: "Syria", dial_code: "+963" },
    { name: "Taiwan", dial_code: "+886" },
    { name: "Tajikistan", dial_code: "+992" },
    { name: "Tanzania", dial_code: "+255" },
    { name: "Thailand", dial_code: "+66" },
    { name: "Timor-Leste", dial_code: "+670" },
    { name: "Togo", dial_code: "+228" },
    { name: "Tokelau", dial_code: "+690" },
    { name: "Tonga", dial_code: "+676" },
    { name: "Trinidad and Tobago", dial_code: "+1868" },
    { name: "Tunisia", dial_code: "+216" },
    { name: "Turkey", dial_code: "+90" },
    { name: "Turkmenistan", dial_code: "+993" },
    { name: "Turks and Caicos Islands", dial_code: "+1649" },
    { name: "Tuvalu", dial_code: "+688" },
    { name: "Uganda", dial_code: "+256" },
    { name: "Ukraine", dial_code: "+380" },
    { name: "United Arab Emirates", dial_code: "+971" },
    { name: "United Kingdom", dial_code: "+44" },
    { name: "United States", dial_code: "+1" },
    { name: "Uruguay", dial_code: "+598" },
    { name: "Uzbekistan", dial_code: "+998" },
    { name: "Vanuatu", dial_code: "+678" },
    { name: "Venezuela", dial_code: "+58" },
    { name: "Vietnam", dial_code: "+84" },
    { name: "Yemen", dial_code: "+967" },
    { name: "Zambia", dial_code: "+260" },
    { name: "Zimbabwe", dial_code: "+263" }
  ];

 const toggleLeadDateSort = () => {

  let newOrder;

  if (leadDateSortOrder === null) {

    newOrder = "asc";

  } else if (leadDateSortOrder === "asc") {

    newOrder = "desc";

  } else {

    newOrder = "asc";

  }

  setLeadDateSortOrder(newOrder);

  setStudents((prev) => {

    const sortedStudents = [...prev].sort(
      (a, b) => {

        const dateA = dayjs(
          a.LeadDate,
          ["YYYY-MM-DD", "DD-MM-YYYY"]
        ).valueOf();

        const dateB = dayjs(
          b.LeadDate,
          ["YYYY-MM-DD", "DD-MM-YYYY"]
        ).valueOf();

        return newOrder === "asc"
          ? dateA - dateB
          : dateB - dateA;

      }
    );

    return sortedStudents;

  });

};

// ================= SORT FUNCTION =================

// const toggleLeadSourceSort = () => {

//   const newOrder =
//     leadSourceSortOrder === "asc"
//       ? "desc"
//       : "asc";

//   setLeadSourceSortOrder(newOrder);

//   setStudents((prev) => {

//     const sortedStudents = [...prev].sort(
//       (a, b) => {

//         const sourceA =
//           (a.LeadSource || "").toLowerCase();

//         const sourceB =
//           (b.LeadSource || "").toLowerCase();

//         return newOrder === "asc"
//           ? sourceA.localeCompare(sourceB)
//           : sourceB.localeCompare(sourceA);

//       }
//     );

//     return sortedStudents;

//   });

// };


// ================= SORT FUNCTION =================

const toggleAvailabilityBatchSort = () => {

  let newOrder;

  if (availabilityBatchSortOrder === null) {

    newOrder = "asc";

  } else if (
    availabilityBatchSortOrder === "asc"
  ) {

    newOrder = "desc";

  } else {

    newOrder = "asc";

  }

  setAvailabilityBatchSortOrder(newOrder);

  setStudents((prev) => {

    const sortedStudents = [...prev].sort(
      (a, b) => {

        const parseBatchDate = (value) => {

          if (!value || value === "NA") {
            return null;
          }

          const parts = value.split("-");

          if (parts.length !== 3) {
            return null;
          }

          const day = parts[0];

          const month =
            parts[1].charAt(0).toUpperCase() +
            parts[1].slice(1).toLowerCase();

          const year = parts[2];

          const formattedDate =
            `${day}-${month}-${year}`;

          return dayjs(
            formattedDate,
            "DD-MMMM-YYYY",
            true
          ).valueOf();

        };

        const dateA =
          parseBatchDate(a.AvailabilityBatch);

        const dateB =
          parseBatchDate(b.AvailabilityBatch);

        // KEEP NA AT BOTTOM
        if (dateA === null) return 1;

        if (dateB === null) return -1;

        return newOrder === "asc"
          ? dateA - dateB
          : dateB - dateA;

      }
    );

    return sortedStudents;

  });

};

const handleChangeCallStatus = async () => {
  if (!callStatusRecord?.Email) {
    toast.error("No lead selected");
    return;
  }

  if (!callStatusValue) {
    toast.error("Please choose a status");
    return;
  }

  setCallStatusLoading(true);

  try {
    const url = `${process.env.REACT_APP_API_URL}/leads/update-student-call-status`;

    const payload = {
      Email: callStatusRecord.Email,
      CallStatus: callStatusValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || "Call status updated successfully");

      fetchStudents();

      setCallStatusModalVisible(false);
      setCallStatusRecord(null);
      setCallStatusValue(null);
    } else {
      toast.error(res?.data?.message || "Failed to update call status");
    }
  } catch (err) {
    console.error("change-call-status error", err);

    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Network/server error"
    );
  } finally {
    setCallStatusLoading(false);
  }
};


const handleUpdateComment = async () => {
  if (!commentRecord?.Email) {
    toast.error("No lead selected");
    return;
  }

  if (!commentValue.trim()) {
    toast.error("Please enter comment");
    return;
  }

  setCommentLoading(true);

  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/leads/update-student-comment`,
      {
        Email: commentRecord.Email,
        Comment: commentValue.trim(),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res?.data?.success || res?.status === 200) {
      toast.success(res?.data?.message || "Comment updated successfully");

      fetchStudents();

      setCommentModalVisible(false);
      setCommentRecord(null);
      setCommentValue("");
    }
  } catch (error) {
    console.error(error);

    toast.error(
      error?.response?.data?.message || "Failed to update comment"
    );
  } finally {
    setCommentLoading(false);
  }
};

  // --- Table columns (student) - FullName clickable to edit ---
  const studentColumns = [
    {
      title: <span className="text-[17px] font-bold text-white">Full Name</span>,
      dataIndex: 'FullName',
      key: 'FullName',
      width: 240,
      ellipsis: true,
      render: (t, record) => (
        <a onClick={() => openStudentModal(record)} className="ml-5 text-sm font-bold underline cursor-pointer whitespace-nowrap">
          {t ?? '-'}
        </a>
      ),
    },
    {
      title: <span className="text-[17px] font-bold text-white">Email</span>,
      dataIndex: 'Email',
      key: 'Email',
      width: 260,
      ellipsis: true,
      render: (t) => <span className="ml-4 font-bold whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Phone Number</span>,
      dataIndex: 'PhoneNumber',
      key: 'PhoneNumber',
      width: 200,
      ellipsis: true,
      render: (t) => <span className="ml-4 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Lead Category</span>,
      dataIndex: 'LeadCategory',
      key: 'LeadCategory',
      width: 160,
      ellipsis: true,
      render: (t) => <span className="ml-5 text-sm font-bold whitespace-nowrap">{t ?? '-'}</span>,
    },
  {
  title: (
    <div className="flex items-center gap-2">

      <span className="text-[17px] font-bold text-white">
        Lead Date
      </span>

      <button
        onClick={toggleLeadDateSort}
        className="flex items-center gap-1 px-2 py-1 transition-all duration-200 rounded-md bg-white/10 hover:bg-white/20"
      >

        <SwapOutlined className="text-xs text-white rotate-90" />

       <span className="text-[11px] font-bold text-white uppercase">

  {leadDateSortOrder || "--"}

</span>

      </button>

    </div>
  ),

  dataIndex: "LeadDate",

  key: "LeadDate",

  width: 190,

  render: (d) => (

    <span className="ml-5 font-bold text-center text-blue-600 whitespace-nowrap">

      {d ?? "-"}

    </span>

  ),
},
  {
      title: <span className="text-[17px] font-bold text-white">Lead Source</span>,
      dataIndex: 'LeadSource',
      key: 'LeadSource',
      width: 170,
      ellipsis: true,
      render: (t) => <span className="ml-3 text-sm font-bold text-black whitespace-nowrap">{t ?? '-'}</span>,
    },
   {
  title: (
    <span className="text-[17px] font-bold text-white">
      Call Status
    </span>
  ),

  dataIndex: "CallStatus",

  key: "CallStatus",

  width: 210,

  align: "center",

  render: (t, record) => {

    const status =
      String(t ?? "PENDING").toUpperCase();

    let style = {
      backgroundColor: "#6b7280",
      borderColor: "#6b7280",
      color: "#fff",
    };

    // ================= STATUS COLORS =================

    switch (status) {

      case "PENDING":

        style = {
          backgroundColor: "#dc2626",
          borderColor: "#dc2626",
          color: "#fff",
        };

        break;

      case "INTERESTED":

        style = {
          backgroundColor: "#16a34a",
          borderColor: "#16a34a",
          color: "#fff",
        };

        break;

      case "NOT INTERESTED":

        style = {
          backgroundColor: "#111827",
          borderColor: "#111827",
          color: "#fff",
        };

        break;

      case "FOLLOW UP":

        style = {
          backgroundColor: "#ca8a04",
          borderColor: "#ca8a04",
          color: "#fff",
        };

        break;

      case "CONNECT TO INSTRUCTOR":

        style = {
          backgroundColor: "#2563eb",
          borderColor: "#2563eb",
          color: "#fff",
        };

        break;

      default:

        style = {
          backgroundColor: "#6b7280",
          borderColor: "#6b7280",
          color: "#fff",
        };

    }

    return (

      <div className="flex justify-center">

        <button
          type="button"
          onClick={() => {

            setCallStatusRecord(record);

            const currentStatus =
              String(
                record?.CallStatus ?? "PENDING"
              ).toUpperCase();

            setCallStatusValue(
              currentStatus !== "PENDING"
                ? currentStatus
                : null
            );

            setCallStatusModalVisible(true);

          }}

          className="px-3 py-1.5 rounded-md font-semibold text-sm   "

          style={{
            minWidth: 210,
            ...style
          }}
        >

          {status}

        </button>

      </div>

    );

  },
},

{
  title: <span className="text-[17px] font-bold text-white">Comment</span>,
  dataIndex: "Comment",
  key: "Comment",
  width: 360,
  align: "center",
  render: (t, record) => {
    const comment = t || "No comment";

    return (
      <div className="flex flex-col items-center gap-2">
        <span className="max-w-[290px] truncate text-sm font-semibold text-gray-700">
          {comment}
        </span>

        <Button
          size="small"
          type="primary"
          onClick={() => {
            setCommentRecord(record);
            setCommentValue(record?.Comment || "");
            setCommentModalVisible(true);
          }}
          className="!bg-purple-700 hover:!bg-purple-900 !font-bold"
        >
          Update
        </Button>
      </div>
    );
  },
},
    {
      title: <span className="text-[17px] font-bold text-white">Enrollment Type</span>,
      dataIndex: 'EnrollmentType',
      key: 'EnrollmentType',
      width: 290,
      ellipsis: true,
      render: (t) => <span className="ml-3 text-sm font-bold text-red-700 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">College Name</span>,
      dataIndex: 'CollegeName',
      key: 'CollegeName',
      width: 320,
      ellipsis: true,
      render: (t) => <span className="text-sm ml-14 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Passed Out year</span>,
      dataIndex: 'PassedOutYear',
      key: 'PassedOutYear',
      width: 160,
      ellipsis: true,
      render: (t) => <span className="ml-5 text-sm whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
  title: (
    <div className="flex items-center gap-2">

      <span className="text-[17px] font-bold text-white">
        Availability Batch
      </span>

      <button
        onClick={toggleAvailabilityBatchSort}
        className="flex items-center gap-1 px-2 py-1 transition-all duration-200 rounded-md bg-white/10 hover:bg-white/20"
      >

        <SwapOutlined className="text-xs text-white rotate-90" />

        <span className="text-[11px] font-bold text-white uppercase">

  {availabilityBatchSortOrder || "--"}

</span>

      </button>

    </div>
  ),

  dataIndex: "AvailabilityBatch",

  key: "AvailabilityBatch",

  width: 230,

  ellipsis: true,

  render: (t) => (

    <span className="font-bold text-green-700 whitespace-nowrap">

      {t ?? "-"}

    </span>

  ),
},
    {
      title: <span className="text-[17px] font-bold text-white">Batch Day</span>,
      dataIndex: 'BatchDay',
      key: 'BatchDay',
      width: 140,
      ellipsis: true,
      render: (t) => <span className="ml-4 text-sm font-bold whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Call Back</span>,
      dataIndex: 'CallBack',
      key: 'CallBack',
      width: 140,
      ellipsis: true,
      render: (t) => <span className="ml-5 text-sm whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Message</span>,
      dataIndex: 'Message',
      key: 'Message',
      width: 600,
      ellipsis: true,
      render: (t) => <span className="ml-5 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
  title: (
    <span className="font-bold text-[17px] text-white whitespace-nowrap">
      Action
    </span>
  ),
  key: 'action',
  fixed: 'right',
  width: 220,
  align: 'center',
  render: (_, record) => (
    <div className="flex items-center justify-center gap-2">
      <button
        onClick={() => openActionModal(record)}
        className="px-4 py-2 font-semibold text-white rounded-md shadow bg-gradient-to-r from-blue-600 to-blue-500 hover:from-red-700 hover:to-rose-600"
        type="button"
      >
        Actions
      </button>
    </div>
  ),
}

  ];


  // ================= SORT PROFESSIONAL LEAD DATE =================

const toggleProfessionalLeadDateSort = () => {

  let newOrder;

  if (professionalLeadDateSortOrder === null) {

    newOrder = "asc";

  } else if (
    professionalLeadDateSortOrder === "asc"
  ) {

    newOrder = "desc";

  } else {

    newOrder = "asc";

  }

  setProfessionalLeadDateSortOrder(newOrder);

  setProfessionals((prev) => {

    const sortedProfessionals = [...prev].sort(
      (a, b) => {

        const dateA = dayjs(
          a.LeadDate,
          ["YYYY-MM-DD", "DD-MM-YYYY"]
        ).valueOf();

        const dateB = dayjs(
          b.LeadDate,
          ["YYYY-MM-DD", "DD-MM-YYYY"]
        ).valueOf();

        return newOrder === "asc"
          ? dateA - dateB
          : dateB - dateA;

      }
    );

    return sortedProfessionals;

  });

};


// ================= SORT AVAILABILITY BATCH =================

const toggleProfessionalAvailabilityBatchSort = () => {

  let newOrder;

  if (
    professionalAvailabilityBatchSortOrder === null
  ) {

    newOrder = "asc";

  } else if (
    professionalAvailabilityBatchSortOrder === "asc"
  ) {

    newOrder = "desc";

  } else {

    newOrder = "asc";

  }

  setProfessionalAvailabilityBatchSortOrder(
    newOrder
  );

  setProfessionals((prev) => {

    const sortedProfessionals = [...prev].sort(
      (a, b) => {

        const parseBatchDate = (value) => {

          if (!value || value === "NA") {
            return null;
          }

          const parts = value.split("-");

          if (parts.length !== 3) {
            return null;
          }

          const day = parts[0];

          const month =
            parts[1].charAt(0).toUpperCase() +
            parts[1].slice(1).toLowerCase();

          const year = parts[2];

          const formattedDate =
            `${day}-${month}-${year}`;

          return dayjs(
            formattedDate,
            "DD-MMMM-YYYY",
            true
          ).valueOf();

        };

        const dateA =
          parseBatchDate(a.AvailabilityBatch);

        const dateB =
          parseBatchDate(b.AvailabilityBatch);

        // KEEP NA AT BOTTOM
        if (dateA === null) return 1;

        if (dateB === null) return -1;

        return newOrder === "asc"
          ? dateA - dateB
          : dateB - dateA;

      }
    );

    return sortedProfessionals;

  });

};


const handleChangeProfessionalCallStatus = async () => {
  if (!professionalCallStatusRecord?.Email) return toast.error("No lead selected");
  if (!professionalCallStatusValue) return toast.error("Please choose a status");

  setProfessionalCallStatusLoading(true);

  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/leads/update-professional-call-status`,
      {
        Email: professionalCallStatusRecord.Email,
        CallStatus: professionalCallStatusValue,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res?.data?.success || res?.status === 200) {
      toast.success(res?.data?.message || "Call status updated successfully");
      fetchProfessionals();

      setProfessionalCallStatusModalVisible(false);
      setProfessionalCallStatusRecord(null);
      setProfessionalCallStatusValue(null);
    }
  } catch (error) {
    console.log(error);
    
    toast.error(error?.response?.data?.message || "Failed to update call status");
  } finally {
    setProfessionalCallStatusLoading(false);
  }
};

const handleUpdateProfessionalComment = async () => {
  if (!professionalCommentRecord?.Email) return toast.error("No lead selected");
  if (!professionalCommentValue.trim()) return toast.error("Please enter comment");

  setProfessionalCommentLoading(true);

  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/leads/update-professional-comment`,
      {
        Email: professionalCommentRecord.Email,
        Comment: professionalCommentValue.trim(),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res?.data?.success || res?.status === 200) {
      toast.success(res?.data?.message || "Comment updated successfully");
      fetchProfessionals();

      setProfessionalCommentModalVisible(false);
      setProfessionalCommentRecord(null);
      setProfessionalCommentValue("");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to update comment");
  } finally {
    setProfessionalCommentLoading(false);
  }
};
  

  // --- Table columns (professional) - FullName clickable to edit ---
  const professionalColumns = [
    {
      title: <span className="text-[17px] font-bold text-white text-center">Full Name</span>,
      dataIndex: 'FullName',
      key: 'FullName',
      width: 240,
      ellipsis: true,
      render: (t, record) => (
        <a onClick={() => openProfessionalModal(record)} className="ml-5 text-sm font-bold text-center underline truncate cursor-pointer whitespace-nowrap">
          {t ?? '-'}
        </a>
      ),
    },
    {
      title: <span className="text-[17px] font-bold text-white text-center">Email</span>,
      dataIndex: 'Email',
      key: 'Email',
      width: 260,
      ellipsis: true,
      render: (t) => <span className="font-bold whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Phone Number</span>,
      dataIndex: 'PhoneNumber',
      key: 'PhoneNumber',
      width: 160,
      ellipsis: true,
      render: (t) => <span className="truncate whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Lead Category</span>,
      dataIndex: 'LeadCategory',
      key: 'LeadCategory',
      width: 160,
      ellipsis: true,
      render: (t) => <span className="text-sm truncate whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
  title: (
    <div className="flex items-center gap-2">

      <span className="text-[17px] font-bold text-white">
        Lead Date
      </span>

      <button
        onClick={toggleProfessionalLeadDateSort}
        className="flex items-center gap-1 px-2 py-1 transition-all duration-200 rounded-md bg-white/10 hover:bg-white/20"
      >

        <SwapOutlined className="text-xs text-white rotate-90" />

        <span className="text-[11px] font-bold text-white uppercase">

          {professionalLeadDateSortOrder || "--"}

        </span>

      </button>

    </div>
  ), 

  dataIndex: "LeadDate",

  key: "LeadDate",

  width: 190,

  render: (d) => (

    <span className="font-bold text-blue-600 whitespace-nowrap">

      {d || "-"}

    </span>

  ),
},
    {
      title: <span className="text-[17px] font-bold text-white">Lead Source</span>,
      dataIndex: 'LeadSource',
      key: 'LeadSource',
      width: 210,
      ellipsis: true,
      render: (t) => <span className="ml-6 text-sm font-bold truncate whitespace-nowrap">{t ?? '-'}</span>,
    },
     {
  title: (
    <span className="text-[17px] font-bold text-white">
      Call Status
    </span>
  ),

  dataIndex: "CallStatus",
  key: "CallStatus",
  width: 210,
  align: "center",

  render: (t, record) => {

    const status =
      String(t ?? "PENDING").toUpperCase();

    let style = {
      backgroundColor: "#6b7280",
      borderColor: "#6b7280",
      color: "#fff",
    };

    // ================= STATUS COLORS =================

    switch (status) {

      case "PENDING":

        style = {
          backgroundColor: "#dc2626",
          borderColor: "#dc2626",
          color: "#fff",
        };

        break;

      case "INTERESTED":

        style = {
          backgroundColor: "#16a34a",
          borderColor: "#16a34a",
          color: "#fff",
        };

        break;

      case "NOT INTERESTED":

        style = {
          backgroundColor: "#111827",
          borderColor: "#111827",
          color: "#fff",
        };

        break;

      case "FOLLOW UP":

        style = {
          backgroundColor: "#ca8a04",
          borderColor: "#ca8a04",
          color: "#fff",
        };

        break;

      case "CONNECT TO INSTRUCTOR":

        style = {
          backgroundColor: "#2563eb",
          borderColor: "#2563eb",
          color: "#fff",
        };

        break;

      default:

        style = {
          backgroundColor: "#6b7280",
          borderColor: "#6b7280",
          color: "#fff",
        };

    }

    return (

      <div className="flex justify-center">

        <button
          type="button"
          onClick={() => {
  setProfessionalCallStatusRecord(record);

  const currentStatus = String(record?.CallStatus ?? "PENDING").toUpperCase();

  setProfessionalCallStatusValue(
    currentStatus !== "PENDING" ? currentStatus : null
  );

  setProfessionalCallStatusModalVisible(true);
}}

          className="px-3 py-1.5 rounded-md font-semibold text-sm   "

          style={{
            minWidth: 210,
            ...style
          }}
        >

          {status}

        </button>

      </div>

    );

  },
},

{
  title: <span className="text-[17px] font-bold text-white">Comment</span>,
  dataIndex: "Comment",
  key: "Comment",
  width: 360,
  align: "center",
  render: (t, record) => {
    const comment = t || "No comment";

    return (
      <div className="flex flex-col items-center gap-2">
        <span className="max-w-[290px] truncate text-sm font-semibold text-gray-700">
          {comment}
        </span>

        <Button
          size="small"
          type="primary"
          onClick={() => {
  setProfessionalCommentRecord(record);
  setProfessionalCommentValue(record?.Comment || "");
  setProfessionalCommentModalVisible(true);
}}
          className="!bg-purple-700 hover:!bg-purple-900 !font-bold"
        >
          Update
        </Button>
      </div>
    );
  },
},
    {
      title: <span className="text-[17px] font-bold text-white">Enrollment Type</span>,
      dataIndex: 'EnrollmentType',
      key: 'EnrollmentType',
      width: 270,
      ellipsis: true,
      render: (t) => <span className="ml-3 text-sm font-bold text-red-700 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Years Of Exp</span>,
      dataIndex: 'YearsOfExperience',
      key: 'YearsOfExperience',
      width: 150,
      ellipsis: true,
      render: (t) => <span className="truncate ml-9 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white text-center">Company Name</span>,
      dataIndex: 'CompanyName',
      key: 'CompanyName',
      width: 320,
      ellipsis: true,
      render: (t) => <span className="text-sm truncate ml-9 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
  title: (
    <div className="flex items-center gap-2">

      <span className="text-[17px] font-bold text-white">
        Availability Batch
      </span>

      <button
        onClick={
          toggleProfessionalAvailabilityBatchSort
        }
        className="flex items-center gap-1 px-2 py-1 transition-all duration-200 rounded-md bg-white/10 hover:bg-white/20"
      >

        <SwapOutlined className="text-xs text-white rotate-90" />

        <span className="text-[11px] font-bold text-white uppercase">

          {professionalAvailabilityBatchSortOrder || "--"}

        </span>

      </button>

    </div>
  ),

  dataIndex: "AvailabilityBatch",

  key: "AvailabilityBatch",

  width: 210,

  ellipsis: true,

  render: (t) => (

    <span className="font-bold text-green-700 truncate whitespace-nowrap">

      {t ?? "-"}

    </span>

  ),
},
    {
      title: <span className="text-[17px] font-bold text-white">Batch Day</span>,
      dataIndex: 'BatchDay',
      key: 'BatchDay',
      width: 160,
      ellipsis: true,
      render: (t) => <span className="ml-8 text-sm truncate whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Call Back</span>,
      dataIndex: 'CallBack',
      key: 'CallBack',
      width: 160,
      ellipsis: true,
      render: (t) => <span className="ml-10 text-sm font-semibold truncate whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
      title: <span className="text-[17px] font-bold text-white">Message</span>,
      dataIndex: 'Message',
      key: 'Message',
      width: 600,
      ellipsis: true,
      render: (t) => <span className="ml-5 whitespace-nowrap">{t ?? '-'}</span>,
    },
    {
  title: (
    <span className="font-bold text-[17px] text-white whitespace-nowrap">
      Action
    </span>
  ),
  key: 'action',
  fixed: 'right',
  width: 220,
  align: 'center',
  render: (_, record) => (
    <div className="flex items-center justify-center gap-2">
      <button
        onClick={() => openActionModal(record)}
        className="px-4 py-2 font-semibold text-white rounded-md shadow bg-gradient-to-r from-blue-600 to-blue-500 hover:from-red-700 hover:to-rose-600"
        type="button"
      >
        Actions
      </button>
    </div>
  ),
}

  ];

  message.config({
    top: 80,
    duration: 3,
    maxCount: 2,
  });

  const [actionModalVisible, setActionModalVisible] = useState(false);
const [actionRecord, setActionRecord] = useState(null);

const openActionModal = (record) => {
  setActionRecord(record);
  setActionModalVisible(true);
};



  let juniorFilter = filteredStudents.filter(r => {
    return r.EnrollmentType === 'JUNIOR PENETRATION TESTER'
  })

  let seniorFilter = filteredStudents.filter(r => {
    return r.EnrollmentType === 'SENIOR PENETRATION TESTER'
  })

   let juniorFilterProfessionals = filteredProfessionals.filter(r => {
    return r.EnrollmentType === 'JUNIOR PENETRATION TESTER'
  })

  let seniorFilterProfessionals = filteredProfessionals.filter(r => {
    return r.EnrollmentType === 'SENIOR PENETRATION TESTER'
  })
  

  const buildNurturingPayload = (record) => ({
  FullName: record.FullName ?? '',
  Email: record.Email,
  PhoneNumber: record.PhoneNumber ?? '',
  LeadCategory: record.LeadCategory ?? '',
  LeadSource: record.LeadSource ?? '',
  EnrollmentType: record.EnrollmentType ?? '',
  AvailabilityBatch: record.AvailabilityBatch ?? '',
  BatchDay: record.BatchDay ?? '',
});

const handleMoveToNurturingStudent = async (record) => {
  if (!record || !record.Email) {
    toast.error('Selected student record missing Email');
    return;
  }

  const payload = buildNurturingPayload(record);

  setMovingKeys((prev) => new Set(prev).add(record.key));

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/leads/from-leads-to-nurturing-student`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res?.data?.success || res?.status === 201) {
      toast.success(res?.data?.message || 'Moved to Nurturing (Student)');
      setStudents((prev) =>
        prev.filter((r) => r.key !== record.key && r.Email !== record.Email)
      );

        // ✅ CLOSE MODAL
  setActionModalVisible(false);
  setActionRecord(null);
    } else {
      toast.error(res?.data?.message || 'Failed to move student to nurturing');
    }
  } catch (err) {
    console.error('Move student to nurturing failed', err);
    toast.error(err?.response?.data?.message || 'Network / server error');
  } finally {
    setMovingKeys((prev) => {
      const next = new Set(prev);
      next.delete(record.key);
      return next;
    });
  }
};


const handleMoveToNurturingProfessional = async (record) => {
  if (!record || !record.Email) {
    toast.error('Selected professional record missing Email');
    return;
  }

  const payload = buildNurturingPayload(record);

  setMovingKeys((prev) => new Set(prev).add(record.key));

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/leads/from-leads-to-nurturing-professional`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res?.data?.success || res?.status === 201) {
      toast.success(res?.data?.message || 'Moved to Nurturing (Professional)');
      setProfessionals((prev) =>
        prev.filter((r) => r.key !== record.key && r.Email !== record.Email)
      );

        // ✅ CLOSE MODAL
  setActionModalVisible(false);
  setActionRecord(null);
    } else {
      toast.error(res?.data?.message || 'Failed to move professional to nurturing');
    }
  } catch (err) {
    console.error('Move professional to nurturing failed', err);
    toast.error(err?.response?.data?.message || 'Network / server error');
  } finally {
    setMovingKeys((prev) => {
      const next = new Set(prev);
      next.delete(record.key);
      return next;
    });
  }
};


// const showLeadNotification = (lead) => {
//   // console.log('🔔 Showing notification');

//   if (!('Notification' in window)) {
//     console.error('Browser does not support notifications');
//     return;
//   }
// if (Notification.permission === 'granted') {
//   setTimeout(() => {
//     new Notification('🚀 New Lead Alert', {
//       body: `👤 Name: ${lead.FullName}
// 📧 Email: ${lead.Email ?? 'N/A'}
// 🎯 Type: ${lead.LeadCategory}
// 📍 Enrollment: ${lead.EnrollmentType ?? 'N/A'}`,
//       icon: '/alert.png', // absolute path from site root
//     });
//   }, 1000);
// } else {
//     console.warn('Notification permission not granted');
//   }
// };



// useEffect(() => {
//   socket.on('NEW_LEAD', (lead) => {
//     // console.log('📩 NEW_LEAD event received:', lead);
//     showLeadNotification(lead);
//   });

//   return () => socket.off('NEW_LEAD');
// }, []);



// useEffect(() => {
//   socket.on('connect', () => {
//     console.log('✅ Socket connected:', socket.id);
//   });

//   socket.on('disconnect', () => {
//     console.log('❌ Socket disconnected');
//   });
// }, []);

const [dropModalVisible, setDropModalVisible] = useState(false);
const [dropComments, setDropComments] = useState("");
const [dropLoading, setDropLoading] = useState(false);


const handleDropLeadConfirm = async (record) => {
  if (!record?.Email) {
    toast.error("No email present for selected lead");
    return;
  }

  const key = `drop-${record.key}`;
  setMovingKeys(prev => {
    const next = new Set(prev);
    next.add(key);
    return next;
  });

  setDropLoading(true);

  try {
    const isStudent =
      record?.LeadCategory?.toLowerCase() === "student";

    const url = isStudent
      ? `${process.env.REACT_APP_API_URL?.replace(/\/$/, "")}/leads/drop-lead-student`
      : `${process.env.REACT_APP_API_URL?.replace(/\/$/, "")}/leads/drop-lead-professional`;

    const method = isStudent ? "post" : "post";

    const payload = {
      Email: record.Email,
      Comments: dropComments ?? "",
    };

    const res = await axios({
      url,
      method,
      data: payload,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.data?.success || [200, 201].includes(res?.status)) {
      toast.success("Lead dropped successfully");

      if(isStudent){
         setStudents(prev => prev.filter(l => l.key !== record.key));
      } else {
        setProfessionals(prev => prev.filter(l => l.key !== record.key));
      }
     

      setDropModalVisible(false);
      setActionModalVisible(false);
    } else {
      toast.error(res?.data?.message || "Failed to drop lead");
    }
  } catch (err) {
    console.error("Drop lead error", err);
    toast.error(
      err?.response?.data?.message || err.message || "Server error"
    );
  } finally {
    setDropLoading(false);
    setMovingKeys(prev => {
      const next = new Set(prev);
      next.delete(key);
      return next;
    });
  }
};


  return (
    <div className="w-full px-4 py-10 mx-auto bg-white shadow-sm sm:px-6 lg:px-8 rounded-xl">
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        className="!mb-6 !ml-4"
        toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
      />

      <Title
        level={3}
        className="!text-3xl !font-bold text-gray-800 tracking-tight mb-3 border-b border-gray-200 pb-2"
      >
        Leads Dashboard
      </Title>

      <Paragraph className="mb-6 text-lg leading-relaxed text-gray-800">
        Welcome to the <span className="font-semibold text-blue-600"> Leads</span>. Below you
        can view and manage leads captured for both <span className="font-semibold text-black">Students</span>{' '}
        and <span className="font-semibold text-black">Professionals</span>. Use the tabs to switch between categories. <br />
      </Paragraph>

      <p className="text-lg text-slate-700">
        You can access all lead details anytime from the{" "}
        <Link
          to={fullPath}
          className="inline-flex items-center gap-2 px-3 py-1 text-lg font-semibold text-red-600 bg-gray-100 rounded-md hover:bg-gray-200"
        >
          Leads Dashboard
        </Link>
      </p>

      {error && (
        <Alert
          type="error"
          message="Error Loading Leads"
          description={error}
          showIcon
          closable
          className="mb-6"
          onClose={() => setError(null)}
        />
      )}

{/* Shared search row */}
      <div className="flex items-center gap-4 mb-4">
        <div className="flex items-center gap-2">
          <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">Full Name</label>
          <Search
            placeholder="Search Full Name"
            allowClear
            value={filterFullNameText}
            onChange={(e) => setFilterFullNameText(e.target.value)}
            onSearch={(v) => setFilterFullNameText(v)}
            style={{ minWidth: 280,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
            enterButton={false}
          />
        </div>

        <div className="flex items-center gap-2">
          <label className="text-sm font-semibold text-gray-700">Email</label>
          <Search
            placeholder="Search Email"
            allowClear
            value={filterEmailText}
            onChange={(e) => setFilterEmailText(e.target.value)}
            onSearch={(v) => setFilterEmailText(v)}
            style={{ minWidth: 280,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
            enterButton={false}
          />
        </div>

        <div className="flex items-center gap-2 ">
          <Button className="font-semibold text-black bg-blue-400 border border-gray-400 hover:bg-gray-500" onClick={clearAllFilters} type="default">Clear All Filters</Button>
        </div>
      </div>
          

      <div className="mt-6">
        <Tabs
          defaultActiveKey="students"
          destroyInactiveTabPane={false}
          className="[&_.ant-tabs-nav]:border-b-2 [&_.ant-tabs-nav]:border-gray-200"
        >
          
          <TabPane
            tab={
              <span className="text-lg font-bold text-gray-900 ">
                Student Leads {loadingStudents && <Spin size="small" className="ml-2" />}
              </span>
            }
            key="students"
          >

            {/* Student filters */}
                        <div className="flex flex-wrap items-center gap-4 mb-4">
                          <div className="flex items-center gap-2">
                            <label className="text-sm font-semibold text-gray-700">Lead Source</label>
                            <Select mode="multiple" placeholder={<span style={{ color: '#4b5563' }}>Select Sourse</span>} value={studentSources} onChange={(v) => setStudentSources(v)} style={{ minWidth: 200,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                              options={[
                                { label: 'Google', value: 'GOOGLE' },
                                { label: 'Meta', value: 'META' },
                                { label: 'Meta-Instagram', value: 'META-INSTAGRAM' },
             { label: 'Meta-Facebook', value: 'META-FACEBOOK' },
                                { label: 'LinkedIn', value: 'LINKEDIN' },
                                { label: 'Organic', value: 'ORGANIC' },
                                 { label: 'Youtube', value: 'YOUTUBE' },
                                 { label: 'Youtube-Infeed', value: 'YOUTUBE-YIF' },
                       { label: 'Youtube-Instream', value: 'YOUTUBE-YIS' },
                              ]}
                            />
                          </div>

                          <div className="flex items-center gap-2">
                            <label className="text-sm font-semibold text-gray-700">Call Status</label>
                            <Select mode="multiple" placeholder={<span style={{ color: '#4b5563' }}>Select Call status</span>} value={studentCallStatus} onChange={(v) => setStudentCallStatus(v)} style={{ minWidth: 200,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                              options={[
                                { label: 'PENDING', value: 'PENDING' },
                                { label: 'INTERESTED', value: 'INTERESTED' },
                                { label: 'NOT INTERESTED', value: 'NOT INTERESTED' },
                                { label: 'FOLLOW UP', value: 'FOLLOW UP' },
                                
                                 { label: 'CONNECT TO INSTRUCTOR', value: 'CONNECT TO INSTRUCTOR' },
                              ]}
                            />
                          </div>
            
                         
            
                        
            
                          <div className="flex items-center gap-2">
                            <label className="text-sm font-semibold text-gray-700">Registered Month</label>
                            <Select placeholder={<span style={{ color: '#4b5563' }}>Any Month</span>} value={studentRegisteredMonth} onChange={(v) => setStudentRegisteredMonth(v)} allowClear style={{ minWidth: 140,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                              options={[
                                { label: 'JANUARY', value: 'JANUARY' }, { label: 'FEBRUARY', value: 'FEBRUARY' }, { label: 'MARCH', value: 'MARCH' },
                                { label: 'APRIL', value: 'APRIL' }, { label: 'MAY', value: 'MAY' }, { label: 'JUNE', value: 'JUNE' },
                                { label: 'JULY', value: 'JULY' }, { label: 'AUGUST', value: 'AUGUST' }, { label: 'SEPTEMBER', value: 'SEPTEMBER' },
                                { label: 'OCTOBER', value: 'OCTOBER' }, { label: 'NOVEMBER', value: 'NOVEMBER' }, { label: 'DECEMBER', value: 'DECEMBER' },
                              ]}
                            />
                          </div>
            
                          {/* Enrollment Type */}
                                        <div className="flex items-center gap-2">
                                          <label className="text-sm font-semibold text-gray-700">Enrollment Type</label>
                                          <Select
                                            placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
                                            value={studentEnrollmentType}
                                            onChange={(v) => setStudentEnrollmentType(v || null)}
                                            allowClear
                                            style={{ minWidth: 220, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                                            options={[ { label: 'JUNIOR PENETRATION TESTER', value: 'JUNIOR PENETRATION TESTER' }, { label: 'SENIOR PENETRATION TESTER', value: 'SENIOR PENETRATION TESTER' } ]}
                                          />
                                        </div>
            
                          <div className="flex items-center gap-2">
                            <label className="text-sm font-semibold text-gray-700">Batch Day</label>
                            <Select mode="multiple" placeholder={<span style={{ color: '#4b5563' }}>Batch Day</span>} value={studentBatchDays} onChange={(v) => setStudentBatchDays(v)} style={{ minWidth: 160,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                              options={[
                                { label: 'Morning', value: 'MORNING' },
                                { label: 'Evening', value: 'EVENING' },
                              ]}
                            />
                          </div>
            
                          <div >
                            <Button className="font-semibold text-black bg-blue-400 border border-gray-400 hover:bg-gray-500" onClick={clearStudentFilters}>Clear Student Filters</Button>
                          </div>
                        </div>
            
            
            <div className="flex items-center justify-start mb-4">
              <div />
              <div className="flex items-center gap-4 mb-5 mr-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Total Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {filteredStudents.length}
    </div>
  </div> 
</div>

<div className="flex items-center gap-4 mb-5 mr-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Junior Pen Tester Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {juniorFilter.length}
    </div>
  </div> 
</div> 

<div className="flex items-center gap-4 mb-5 mr-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Senior Pen Tester Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {seniorFilter.length}
    </div>
  </div> 
</div> 


             <div className="flex items-center gap-4">

  <Button
    type="primary"
    onClick={() => openStudentModal()}
    icon={<PlusOutlined className="text-lg font-extrabold" />}
    className=" !bg-blue-700 !hover:bg-blue-900 !text-white !font-bold text-lg !px-5 !py-6 !rounded-md !shadow-lg !shadow-blue-300/50 !transition-all !duration-300 !flex !items-center !gap-2"
  >
    Add Student
  </Button>

  <Button
    type="primary"
    onClick={openUploadCSVModal}
    icon={<UploadOutlined className="text-lg font-extrabold" />}
    className=" !bg-green-700 !hover:bg-green-900 !text-white !font-bold text-lg !px-5 !py-6 !rounded-md !shadow-lg !shadow-green-300/50 !transition-all !duration-300 !flex !items-center !gap-2"
  >
    Upload CSV
  </Button>

</div>
            </div>
            

            <Table
              dataSource={filteredStudents}
              columns={[...studentColumns.map((col) => ({ ...col, className: ' text-[15px] font-semibold text-gray-900 px-11 py-1' }))]}
              rowKey={(r) => r.Email || r.key}
              loading={loadingStudents}
              pagination={{ pageSize: 15 }}
              scroll={{ x: 2600 }}
              className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table"
            />
          </TabPane>

          <TabPane
            tab={
              <span className="text-lg font-bold text-gray-800 ">
                Professional Leads {loadingProfessionals && <Spin size="small" className="ml-2" />}
              </span>
            }
            key="professionals"
          >
 {/* Professional filters */}
            <div className="flex flex-wrap items-center gap-4 mb-4">
              <div className="flex items-center gap-2">
                <label className="text-sm font-semibold text-gray-700">Lead Source</label>
                <Select mode="multiple" placeholder={<span style={{ color: '#4b5563' }}>Select Source</span>} value={profSources} onChange={(v) => setProfSources(v)} style={{ minWidth: 200,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                  options={[
                    { label: 'Google', value: 'GOOGLE' },
                    { label: 'Meta', value: 'META' },
                    { label: 'Meta-Instagram', value: 'META-INSTAGRAM' },
             { label: 'Meta-Facebook', value: 'META-FACEBOOK' },
                    { label: 'LinkedIn', value: 'LINKEDIN' },
                    { label: 'Organic', value: 'ORGANIC' },
                     { label: 'Youtube', value: 'YOUTUBE' },
                      { label: 'Youtube-Infeed', value: 'YOUTUBE-YIF' },
                       { label: 'Youtube-Instream', value: 'YOUTUBE-YIS' },
                  ]}
                />
              </div>

                                        <div className="flex items-center gap-2">
                            <label className="text-sm font-semibold text-gray-700">Call Status</label>
                            <Select mode="multiple" placeholder={<span style={{ color: '#4b5563' }}>Select Call status</span>} value={professionalCallStatus} onChange={(v) => setProfessionalCallStatus(v)} style={{ minWidth: 200,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                              options={[
                                { label: 'PENDING', value: 'PENDING' },
                                { label: 'INTERESTED', value: 'INTERESTED' },
                                { label: 'NOT INTERESTED', value: 'NOT INTERESTED' },
                                { label: 'FOLLOW UP', value: 'FOLLOW UP' },
                                
                                 { label: 'CONNECT TO INSTRUCTOR', value: 'CONNECT TO INSTRUCTOR' },
                              ]}
                            />
                          </div>

             

              <div className="flex items-center gap-2">
                <label className="text-sm font-semibold text-gray-700">Years Of Exp</label>
                <Select mode="multiple" placeholder={<span style={{ color: '#4b5563' }}>Years</span>} value={profYears} onChange={(v) => setProfYears(v)} style={{ minWidth: 140,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                  options={[1,2,3,4,5,6].map(n => ({ label: String(n), value: String(n) }))}
                />
              </div>

              <div className="flex items-center gap-2">
                <label className="text-sm font-semibold text-gray-700">Registered Month</label>
                <Select placeholder={<span style={{ color: '#4b5563' }}>Any Month</span>} value={profRegisteredMonth} onChange={(v) => setProfRegisteredMonth(v)} allowClear style={{ minWidth: 140,borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                  options={[
                    { label: 'JANUARY', value: 'JANUARY' }, { label: 'FEBRUARY', value: 'FEBRUARY' }, { label: 'MARCH', value: 'MARCH' },
                    { label: 'APRIL', value: 'APRIL' }, { label: 'MAY', value: 'MAY' }, { label: 'JUNE', value: 'JUNE' },
                    { label: 'JULY', value: 'JULY' }, { label: 'AUGUST', value: 'AUGUST' }, { label: 'SEPTEMBER', value: 'SEPTEMBER' },
                    { label: 'OCTOBER', value: 'OCTOBER' }, { label: 'NOVEMBER', value: 'NOVEMBER' }, { label: 'DECEMBER', value: 'DECEMBER' },
                  ]}
                />
              </div>

              {/* Enrollment Type */}
                            <div className="flex items-center gap-2">
                              <label className="text-sm font-semibold text-gray-700">Enrollment Type</label>
                              <Select
                                placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
                                value={profEnrollmentType}
                                onChange={(v) => setProfEnrollmentType(v || null)}
                                allowClear
                                style={{ minWidth: 220, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                                options={[ { label: 'JUNIOR PENETRATION TESTER', value: 'JUNIOR PENETRATION TESTER' }, { label: 'SENIOR PENETRATION TESTER', value: 'SENIOR PENETRATION TESTER' } ]}
                              />
                            </div>

              <div className="flex items-center gap-2">
                <label className="text-sm font-semibold text-gray-700">Batch Day</label>
                <Select mode="multiple" placeholder={<span style={{ color: '#4b5563' }}>Batch Day</span>} value={profBatchDays} onChange={(v) => setProfBatchDays(v)} style={{ minWidth: 160, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
                  options={[
                    { label: 'Morning', value: 'MORNING' },
                    { label: 'Evening', value: 'EVENING' },
                  ]}
                />
              </div>

              <div >
                <Button className="font-semibold text-black bg-blue-400 border border-gray-400 hover:bg-gray-50" onClick={clearProfessionalFilters}>Clear Professional Filters</Button>
              </div>
            </div>
            
            <div className="flex items-center justify-start mb-4 ">
              <div />

              <div className="flex items-center gap-4 mb-5 mr-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Total Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {filteredProfessionals.length}
    </div>
  </div> 
</div>


<div className="flex items-center gap-4 mb-5 mr-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Junior Pen Tester Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {juniorFilterProfessionals.length}
    </div>
  </div> 
</div> 

<div className="flex items-center gap-4 mb-5 mr-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Senior Pen Tester Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {seniorFilterProfessionals.length}
    </div>
  </div> 
</div> 
              <div className="flex items-center gap-4">

  <Button
    type="primary"
    onClick={() => openProfessionalModal()}
    icon={
      <PlusOutlined className="text-lg font-extrabold" />
    }
    className=" !bg-blue-700 !hover:bg-blue-900 !text-white !font-bold text-lg !px-5 !py-6 !rounded-md !shadow-lg !shadow-blue-300/50 !transition-all !duration-300 !flex !items-center !gap-2"
  >
    Add Professional
  </Button>

  <Button
    type="primary"
    onClick={openUploadProfessionalCSVModal}
    icon={
      <UploadOutlined className="text-lg font-extrabold" />
    }
    className=" !bg-green-700 !hover:bg-green-900 !text-white !font-bold text-lg !px-5 !py-6 !rounded-md !shadow-lg !shadow-green-300/50 !transition-all !duration-300 !flex !items-center !gap-2"
  >
    Upload CSV
  </Button>

</div>
            </div>

            <Table
              dataSource={filteredProfessionals}
              columns={[...professionalColumns.map((col) => ({ ...col, className: ' text-[15px] font-semibold text-gray-900 px-3 py-1' }))]}
              rowKey={(r) => r.Email || r.key}
              loading={loadingProfessionals}
              pagination={{ pageSize: 15 }}
              scroll={{ x: 2600 }}
              className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table"
            />
          </TabPane>
        </Tabs>
      </div>

      {/* Student Modal (Add + Edit) */}
      <Modal
        title={<span className="text-lg font-bold">{isEditingStudent ? 'EDIT STUDENT LEAD' : 'ADD STUDENT LEAD'}</span>}
        open={isStudentModalOpen}
        onCancel={closeStudentModal}
        footer={null}
        destroyOnClose
        width={800}
      >
        <Form
          layout="vertical"
          form={studentForm}
          onFinish={submitStudent}
          initialValues={{
            LeadCategory: 'STUDENT',
            CallBack: 'NO',
          }}
        >
          <Row gutter={[16, 8]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="FullName"
                label="Full Name"
                rules={[{ required: true, message: 'Please enter full name' }]}
                className='font-semibold text-md'
              >
                <Input placeholder="e.g., Tirumala Kumar" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="Email"
                label="Email"
                className='font-semibold text-md'
                rules={[
                  { required: true, message: 'Please enter email' },
                  { type: 'email', message: 'Enter a valid email' },
                ]}
              >
                <Input placeholder="name@example.com" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item label="Phone Number" className='font-semibold text-md'>
                <Input.Group compact>
                  <Form.Item name="CountryCode" noStyle initialValue="+91">
                    <Select style={{ width: '40%' }} defaultValue="+91">
                      {COUNTRIES.map(country => (
                        <Select.Option key={country.dial_code} value={country.dial_code}>
                          {country.name} ({country.dial_code})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="PhoneNumber"
                    noStyle
                    rules={[{ required: true, message: 'Enter phone number' }]}
                  >
                    <Input style={{ width: '72%', marginTop: '2%' }} placeholder="9080432374" />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="LeadCategory" label="Lead Category" className='font-semibold text-md'>
                <Input placeholder="STUDENT (default)" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="LeadSource" label="Lead Source" className='font-semibold text-md'>
                <Select placeholder="Select Lead Source" allowClear>
                  <Option value="GOOGLE">GOOGLE</Option>
                  <Option value="YOUTUBE">YOUTUBE</Option>
                  <Option value="META">META</Option>
                  <Option value="LINKEDIN">LINKEDIN</Option>
                  <Option value="ORGANIC">ORGANIC</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="EnrollmentType" label="Enrollment Type" rules={[{ required: true, message: 'Please select Enrollment Type' }]} className='font-semibold text-md'>
                <Select placeholder="Select Enrollment Type" allowClear>
                  <Option value="JUNIOR PENETRATION TESTER">JUNIOR PENETRATION TESTER</Option>
                  <Option value="SENIOR PENETRATION TESTER">SENIOR PENETRATION TESTER</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="CollegeName" label="College Name" className='font-semibold text-md'>
                <Input placeholder="College / University name" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="PassedOutYear"
                label="Passed Out Year"
                className='font-semibold text-md'
                rules={[
                  {
                    pattern: /^(19|20)\d{2}$/,
                    message: 'Enter a valid year (e.g., 2024)',
                  },
                ]}
              >
                <Input placeholder="e.g., 2024" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="AvailabilityBatch"
                label="Availability Batch"
                className='font-semibold text-md'
                rules={[{ required: true, message: 'Please choose availability date' }]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD-MM-YYYY"
                  placeholder="Select batch date (DD-MM-YYYY)"
                  disabledDate={(current) => current && current < dayjs().startOf('day')}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="BatchDay" label="Batch Day" className='font-semibold text-md' rules={[{ required: true, message: 'Please select Batch Day' }]}>
                <Select placeholder="Select batch day" allowClear>
                  <Option value="MORNING">MORNING</Option>
                  <Option value="EVENING">EVENING</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="CallBack" label="Get a Call Back" className='font-semibold text-md'>
                <Select placeholder="Select call back" allowClear>
                  <Option value="YES">YES</Option>
                  <Option value="NO">NO</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={closeStudentModal}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={submittingStudent}>
              {isEditingStudent ? 'Update Student' : 'Add Student'}
            </Button>
          </div>
        </Form>
      </Modal>

      {/* Professional Modal (Add + Edit) */}
      <Modal
        title={<span className="text-lg font-bold">{isEditingProfessional ? 'EDIT PROFESSIONAL LEAD' : 'ADD PROFESSIONAL LEAD'}</span>}
        open={isProfessionalModalOpen}
        onCancel={closeProfessionalModal}
        footer={null}
        destroyOnClose
        width={800}
      >
        <Form
          layout="vertical"
          form={professionalForm}
          onFinish={submitProfessional}
          initialValues={{
            LeadCategory: "PROFESSIONAL",
            CallBack: "NO",
          }}
        >
          <Row gutter={[16, 8]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="FullName"
                label="Full Name"
                rules={[{ required: true, message: "Please enter full name" }]}
                className='font-semibold text-md'
              >
                <Input placeholder="e.g., Priya Singh" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="Email"
                label="Email"
                rules={[
                  { required: true, message: "Please enter email" },
                  { type: "email", message: "Enter a valid email" },
                ]}
                className='font-semibold text-md'
              >
                <Input placeholder="name@example.com" />
              </Form.Item>
            </Col>

           <Col xs={24} sm={12}>
              <Form.Item label="Phone Number" className='font-semibold text-md'
               rules={[{ required: true }]}
              >
                <Input.Group compact>
                  <Form.Item name="CountryCode" noStyle initialValue="+91">
                    <Select style={{ width: '40%' }} defaultValue="+91">
                      {COUNTRIES.map(country => (
                        <Select.Option key={country.dial_code} value={country.dial_code}>
                          {country.name} ({country.dial_code})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="PhoneNumber"
                    noStyle
                    rules={[{ required: true, message: 'Enter phone number' }]}
                  >
                    <Input style={{ width: '72%', marginTop: '2%' }} placeholder="9080432374" />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="LeadCategory" label="Lead Category" className='font-semibold text-md'>
                <Input placeholder="Professional (default)" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="LeadSource" label="Lead Source" rules={[{ required: true, message: 'Please select Lead Source' }]} className='font-semibold text-md'>
                <Select placeholder="Select Lead Source" allowClear>
                  <Option value="GOOGLE">GOOGLE</Option>
                  <Option value="YOUTUBE">YOUTUBE</Option>
                  <Option value="META">META</Option>
                  <Option value="LINKEDIN">LINKEDIN</Option>
                  <Option value="ORGANIC">ORGANIC</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="EnrollmentType" label="Enrollment Type" rules={[{ required: true, message: 'Please select Enrollment Type' }]} className='font-semibold text-md'>
                <Select placeholder="Select Enrollment Type" allowClear>
                  <Option value="JUNIOR PENETRATION TESTER">JUNIOR PENETRATION TESTER</Option>
                  <Option value="SENIOR PENETRATION TESTER">SENIOR PENETRATION TESTER</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="YearsOfExperience"
                label="Years of Experience"
                className='font-semibold text-md'
                rules={[
                  { required: true, message: "Please enter years of experience" },
                ]}
              >
                <Input placeholder="e.g., 3" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="CompanyName" label="Company Name" className='font-semibold text-md'>
                <Input placeholder="e.g., Infosys, Wipro, or TCS" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="AvailabilityBatch"
                label="Availability Batch"
                className='font-semibold text-md'
                rules={[{ required: true, message: "Please choose availability date" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  placeholder="Select batch date (DD-MM-YYYY)"
                  disabledDate={(current) => current && current < dayjs().startOf("day")}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="BatchDay" label="Batch Day" rules={[{ required: true, message: 'Please select Batch Day' }]} className='font-semibold text-md'>
                <Select placeholder="Select batch day" allowClear>
                  <Option value="MORNING">MORNING</Option>
                  <Option value="EVENING">EVENING</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item name="CallBack" label="Get a Call Back" className='font-semibold text-md'>
                <Select placeholder="Select call back" allowClear>
                  <Option value="YES">YES</Option>
                  <Option value="NO">NO</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <div className="flex justify-end gap-2 mt-4">
            <Button onClick={closeProfessionalModal}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={submittingProfessional}>
              {isEditingProfessional ? 'Update Professional' : 'Add Professional'}
            </Button>
          </div>
        </Form>
      </Modal>


      <Modal
  title={
    <div className="flex items-center justify-start w-full">
      <span className="text-xl font-bold text-gray-900">
        Choose Action For Lead
      </span>
    </div>
  }
  open={actionModalVisible}
  onCancel={() => {
    setActionModalVisible(false);
    setActionRecord(null);
  }}
  footer={null}
  centered
  width={520}
  bodyStyle={{ padding: 24 }}
>
  <div className="space-y-4">
    <div className="flex flex-col text-base font-bold text-gray-900 text-start">
     
      <strong>
        Name: {actionRecord?.FullName || actionRecord?.Email || '-'}
      </strong>
      {actionRecord?.PhoneNumber && (
        <span className="text-base font-bold text-red-600 ">
          Phone Number: ({actionRecord.PhoneNumber})
        </span>
      )}
    </div>

    <div className="flex flex-col gap-3">

      {/* MOVE TO DEMO STAGE */}
      <button
        onClick={() => handleMoveToNextStage(actionRecord)}
        disabled={!actionRecord || movingKeys.has(`move-demo-${actionRecord?.key}`)}
        className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99]
        ${
          movingKeys.has(`move-demo-${actionRecord?.key}`)
            ? 'bg-indigo-400 cursor-wait'
            : 'bg-indigo-600 hover:bg-blue-900'
        }`}
        type="button"
      >
        {movingKeys.has(`move-demo-${actionRecord?.key}`) ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Moving...
          </span>
        ) : (
          'Move To Demo Stage'
        )}
      </button>

      {/* MOVE TO NURTURING STAGE */}
      <button
      
  onClick={() =>
    
    actionRecord?.LeadCategory?.toLowerCase() === 'student'
      ? handleMoveToNurturingStudent(actionRecord)
      : handleMoveToNurturingProfessional(actionRecord)
  }
  disabled={!actionRecord || movingKeys.has(actionRecord?.key)}
  className="w-full px-5 py-3 font-semibold text-white bg-slate-700 rounded-xl hover:bg-black"
>
  Move To Nurturing Stage
</button>

{/* DROP LEAD */}
<button
  onClick={() => {
    if (!actionRecord) return;
    setDropComments("");
    setDropModalVisible(true);
  }}
  className="w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md bg-red-600 hover:bg-red-800 transition-transform active:scale-[0.99]"
  type="button"
>
  Drop Lead
</button>



    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Drop Lead</span>}
  open={dropModalVisible}
  onCancel={() => setDropModalVisible(false)}
  footer={null}
  centered
  width={560}
  destroyOnClose
>
  <div className="space-y-4">

    <div className="text-sm text-gray-700">
      Dropping lead:{" "}
      <strong>
        {actionRecord?.FullName ?? actionRecord?.Email ?? "-"}
      </strong>
    </div>

    <div>
      <label className="block mb-1 text-sm text-gray-700">Email</label>
      <input
        type="text"
        value={actionRecord?.Email ?? ""}
        readOnly
        className="w-full px-3 py-2 text-sm font-semibold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-sm text-gray-700">Comments</label>
      <TextArea
        value={dropComments}
        onChange={(e) => setDropComments(e.target.value)}
        rows={4}
        placeholder="Reason / notes for dropping this lead..."
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <button
        onClick={() => setDropModalVisible(false)}
        className="px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-md"
        type="button"
        disabled={dropLoading}
      >
        Cancel
      </button>

      <button
        onClick={() => handleDropLeadConfirm(actionRecord)}
        className={`px-5 py-2.5 rounded-md text-white font-semibold ${
          dropLoading
            ? "bg-gray-400 cursor-wait"
            : "bg-red-600 hover:bg-red-700"
        }`}
        type="button"
        disabled={dropLoading}
      >
        {dropLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Dropping...
          </span>
        ) : (
          "Drop Lead"
        )}
      </button>
    </div>
  </div>
</Modal>

<Modal
  title="Upload Student Leads CSV"
  open={isUploadCSVModalOpen}
  onCancel={closeUploadCSVModal}
  footer={null}
  centered
>

  <div className="flex flex-col gap-5">

    <div className="p-4 border border-blue-200 rounded-lg bg-blue-50">

      <h2 className="mb-2 text-lg font-bold text-blue-800">
        Add CSV to Upload Student Leads
      </h2>

      <p className="text-sm text-gray-700">
        Only CSV files are allowed. Upload student leads
        in bulk using the predefined CSV format.
      </p>

    </div>

   <Upload
  accept=".csv"
  maxCount={1}
  fileList={uploadFileList}
  beforeUpload={(file) => {

    const isCSV =
      file.type === "text/csv" ||
      file.name.endsWith(".csv");

    if (!isCSV) {

      toast.error("Only CSV files are allowed");

      return Upload.LIST_IGNORE;
    }

    setCsvFile(file);

    setUploadFileList([file]);

   
    return false;
  }}

  onRemove={() => {

    setCsvFile(null);

    setUploadFileList([]);

   

  }}
>

  <Button
    icon={<UploadOutlined />}
    className="w-full h-12 font-semibold"
  >
    Select CSV File
  </Button>

</Upload>

    <Button
      type="primary"
      loading={uploadingCSV}
      onClick={handleUploadCSV}
      className="!bg-green-700 hover:!bg-green-900 !h-12 !font-bold"
    >
      Upload CSV Leads
    </Button>

  </div>

</Modal>

<Modal
  title="Upload Professional Leads CSV"
  open={isUploadProfessionalCSVModalOpen}
  onCancel={closeUploadProfessionalCSVModal}
  footer={null}
  centered
>

  <div className="flex flex-col gap-5">

    <div className="p-4 border border-green-200 rounded-lg bg-green-50">

      <h2 className="mb-2 text-lg font-bold text-green-800">
        Add CSV to Upload Professional Leads
      </h2>

      <p className="text-sm text-gray-700">
        Only CSV files are allowed.
        Upload professional leads in bulk
        using predefined CSV format.
      </p>

    </div>

    <Upload
      accept=".csv"
      maxCount={1}
      fileList={professionalUploadFileList}

      beforeUpload={(file) => {

        const isCSV =
          file.type === "text/csv" ||
          file.name.endsWith(".csv");

        if (!isCSV) {

          toast.error(
            "Only CSV files are allowed"
          );

          return Upload.LIST_IGNORE;
        }

        setProfessionalCSVFile(file);

        setProfessionalUploadFileList([file]);

       

        return false;

      }}

      onRemove={() => {

        setProfessionalCSVFile(null);

        setProfessionalUploadFileList([]);

      

      }}
    >

      <Button
        icon={<UploadOutlined />}
        className="w-full h-12 font-semibold"
      >
        Select CSV File
      </Button>

    </Upload>

    <Button
      type="primary"
      loading={uploadingProfessionalCSV}
      onClick={handleUploadProfessionalCSV}
      className="!bg-green-700 hover:!bg-green-900 !h-12 !font-bold"
    >
      Upload Professional CSV
    </Button>

  </div>

</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Call Status</span>}
  open={callStatusModalVisible}
  onCancel={() => {
    setCallStatusModalVisible(false);
    setCallStatusRecord(null);
    setCallStatusValue(null);
  }}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="mb-2 text-sm text-gray-800">
        Full Name :{" "}
        <strong className="text-red-800">
          {callStatusRecord?.FullName ?? "-"}
        </strong>
      </div>

      <div className="mb-2 text-sm text-gray-800">
        Email :{" "}
        <strong className="text-blue-800">
          {callStatusRecord?.Email ?? "-"}
        </strong>
      </div>

      <div className="text-sm text-gray-800">
        Phone Number :{" "}
        <strong className="text-green-800">
          {callStatusRecord?.PhoneNumber ?? "-"}
        </strong>
      </div>
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">
        Call Status
      </label>

      <Select
        value={callStatusValue}
        onChange={(v) => setCallStatusValue(v)}
        placeholder="Select status"
        style={{ width: "100%" }}
        options={[
          { label: "INTERESTED", value: "INTERESTED" },
          { label: "NOT INTERESTED", value: "NOT INTERESTED" },
          { label: "FOLLOW UP", value: "FOLLOW UP" },
          { label: "CONNECT TO INSTRUCTOR", value: "CONNECT TO INSTRUCTOR" },
        ]}
        disabled={callStatusLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button
        onClick={() => {
          setCallStatusModalVisible(false);
          setCallStatusRecord(null);
          setCallStatusValue(null);
        }}
        disabled={callStatusLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleChangeCallStatus}
        disabled={callStatusLoading || !callStatusValue}
        className="bg-blue-600"
      >
        {callStatusLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Changing...
          </span>
        ) : (
          "Change Call Status"
        )}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Update Lead Comment</span>}
  open={commentModalVisible}
  onCancel={() => {
    setCommentModalVisible(false);
    setCommentRecord(null);
    setCommentValue("");
  }}
  footer={null}
  centered
  width={560}
>
  <div className="space-y-4">
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="mb-2 text-sm text-gray-800">
        Full Name :{" "}
        <strong className="text-red-800">
          {commentRecord?.FullName ?? "-"}
        </strong>
      </div>

      <div className="mb-2 text-sm text-gray-800">
        Email :{" "}
        <strong className="text-blue-800">
          {commentRecord?.Email ?? "-"}
        </strong>
      </div>

      <div className="text-sm text-gray-800">
        Phone Number :{" "}
        <strong className="text-green-800">
          {commentRecord?.PhoneNumber ?? "-"}
        </strong>
      </div>
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">
        Comment
      </label>

      <Input.TextArea
        rows={5}
        value={commentValue}
        onChange={(e) => setCommentValue(e.target.value)}
        placeholder="Enter sales call comment..."
        disabled={commentLoading}
        maxLength={1000}
        showCount
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button
        onClick={() => {
          setCommentModalVisible(false);
          setCommentRecord(null);
          setCommentValue("");
        }}
        disabled={commentLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleUpdateComment}
        disabled={commentLoading || !commentValue.trim()}
        className="bg-blue-600"
      >
        {commentLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Updating...
          </span>
        ) : (
          "Update Comment"
        )}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Professional Call Status</span>}
  open={professionalCallStatusModalVisible}
  onCancel={() => {
    setProfessionalCallStatusModalVisible(false);
    setProfessionalCallStatusRecord(null);
    setProfessionalCallStatusValue(null);
  }}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="mb-2 text-sm text-gray-800">
        Full Name : <strong className="text-red-800">{professionalCallStatusRecord?.FullName ?? "-"}</strong>
      </div>
      <div className="mb-2 text-sm text-gray-800">
        Email : <strong className="text-blue-800">{professionalCallStatusRecord?.Email ?? "-"}</strong>
      </div>
      <div className="text-sm text-gray-800">
        Phone Number : <strong className="text-green-800">{professionalCallStatusRecord?.PhoneNumber ?? "-"}</strong>
      </div>
    </div>

    <Select
      value={professionalCallStatusValue}
      onChange={(v) => setProfessionalCallStatusValue(v)}
      placeholder="Select status"
      style={{ width: "100%" }}
      options={[
        { label: "INTERESTED", value: "INTERESTED" },
        { label: "NOT INTERESTED", value: "NOT INTERESTED" },
        { label: "FOLLOW UP", value: "FOLLOW UP" },
        { label: "CONNECT TO INSTRUCTOR", value: "CONNECT TO INSTRUCTOR" },
      ]}
      disabled={professionalCallStatusLoading}
    />

    <div className="flex justify-end gap-3">
      <Button onClick={() => setProfessionalCallStatusModalVisible(false)}>
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleChangeProfessionalCallStatus}
        disabled={professionalCallStatusLoading || !professionalCallStatusValue}
      >
        {professionalCallStatusLoading ? <Spin size="small" /> : "Change Call Status"}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Update Professional Comment</span>}
  open={professionalCommentModalVisible}
  onCancel={() => {
    setProfessionalCommentModalVisible(false);
    setProfessionalCommentRecord(null);
    setProfessionalCommentValue("");
  }}
  footer={null}
  centered
  width={560}
>
  <div className="space-y-4">
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="mb-2 text-sm text-gray-800">
        Full Name : <strong className="text-red-800">{professionalCommentRecord?.FullName ?? "-"}</strong>
      </div>
      <div className="mb-2 text-sm text-gray-800">
        Email : <strong className="text-blue-800">{professionalCommentRecord?.Email ?? "-"}</strong>
      </div>
      <div className="text-sm text-gray-800">
        Phone Number : <strong className="text-green-800">{professionalCommentRecord?.PhoneNumber ?? "-"}</strong>
      </div>
    </div>

    <Input.TextArea
      rows={5}
      value={professionalCommentValue}
      onChange={(e) => setProfessionalCommentValue(e.target.value)}
      placeholder="Enter professional lead comment..."
      disabled={professionalCommentLoading}
      maxLength={1000}
      showCount
    />

    <div className="flex justify-end gap-3">
      <Button onClick={() => setProfessionalCommentModalVisible(false)}>
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleUpdateProfessionalComment}
        disabled={professionalCommentLoading || !professionalCommentValue.trim()}
      >
        {professionalCommentLoading ? <Spin size="small" /> : "Update Comment"}
      </Button>
    </div>
  </div>
</Modal>


    </div>
  );
}

export default Leads;
